// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:37:44.244Z
// Property: Compass (ID: 5717049565249536)
// Collections: 19 amenities, 9 floorplans (live), 19 photos, 81 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live), 17 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5717049565249536",
  "property_external_id": "4597232",
  "property_zillow_url": "https://www.zillow.com/apartments/melbourne-fl/compass/5Xhx26/",
  "property_apartments_url": "https://www.apartments.com/compass-melbourne-fl/x4b4fdp",
  "property_google_business_url": "https://www.google.com/maps/place/Compass/@28.0539711,-80.6233256,15z/data=!4m2!3m1!1s0x0:0x67cad18ded9d10f1?sa=X&ved=2ahUKEwjG7b7i8-H2AhUVmGoFHd1tCVcQ_BJ6BAgnEAU",
  "property_linkedin_url": null,
  "property_hubspot_id": "6732042114",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "compass",
  "property_name": "Compass",
  "property_website_url": "https://www.compassapartmentliving.com/",
  "property_domain": "https://www.compassapartmentliving.com/",
  "property_address": "3595 Misty Oak Dr",
  "property_full_address": "3595 Misty Oak Dr, Melbourne, FL 32901",
  "property_address_1": "3595 Misty Oak Dr",
  "property_address_2": null,
  "property_address_city": "Melbourne",
  "property_address_state": "FL",
  "property_address_zip_full": "32901-8257",
  "property_address_zip": "32901",
  "property_address_country": "US",
  "property_address_county": "Brevard County",
  "property_neighborhood_address": "Melbourne",
  "property_address_latitude": "28.0539711",
  "property_address_longitude": "-80.6233256",
  "property_email": "compass@alapts.com",
  "property_phone": "(321) 984-3161",
  "property_call_tracking_phone": "689-329-0896",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Waterfront ease in the heart of Melbourne.</strong> Compass pairs lake-view calm with thoughtfully designed one- and two-bedroom homes, screened outdoor space, and relaxed community features—all set for an easy day-to-day near the city’s best connections. Schedule a tour and see the home base waiting here.</p>",
  "property_long_description": "<p><strong>Waterfront ease in the heart of Melbourne.</strong> At Compass, your day starts with a view of the community lake and ends with space to unwind—whether that means a swim at the <a href=\"/amenities\">resort-inspired pool</a>, a workout in the 24-hour fitness center, or a quiet moment by the lakefront gazebo.</p><p>Choose from thoughtfully designed one- and two-bedroom <a href=\"/floor-plans\">floor plans</a> with everyday comforts like full-size washer and dryer, walk-in closets, covered parking, and screened outdoor space. Select homes add elevated finishes such as granite countertops, stainless steel appliances, glass tile backsplash, wood-style flooring, and a farmhouse sink.</p><p>Set near Babcock Street and Palm Bay Road, Compass keeps Melbourne within easy reach—from Florida Tech and Melbourne Orlando International Airport to Downtown Melbourne, the Eau Gallie Arts District, Indian River recreation, and Space Coast beaches. It’s a relaxed, connected home base with the features you want close at hand.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019d02f2-f00c-7266-8d0d-7a52623dd271.webp",
  "property_featured_image_media": {
    "alt_text": "Living room and kitchen area in an apartment",
    "public_id": "019d02f2-f00c-7266-8d0d-7a52623dd271",
    "storage_key": "property/5717049565249536/019d02f2-f00c-7266-8d0d-7a52623dd271.webp",
    "width": 1240,
    "height": 826
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "210",
  "property_year_built": "1986",
  "property_year_renovated": "2020",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "91.42857142857143",
  "property_admin_fee": "250",
  "property_application_fee": "100",
  "property_fees_deposit_info": "Application Fee: $100\nAdministrative Fee: $250\nApplication Approval Fee: Starting at $399\nPet Fee: $375/pet\nMonthly Pet Rent: $30/pet",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "375",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $375 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $375 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8110790.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://americancompass.loftliving.com/login",
  "property_apply_now_url": "https://8110790.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e4d65-f800-77d7-9125-a26f36b136e4.webp",
  "property_primary_logo_media": {
    "alt_text": "Compass Premier Apartments logo",
    "public_id": "019e4d65-f800-77d7-9125-a26f36b136e4",
    "storage_key": "property/5717049565249536/019e4d65-f800-77d7-9125-a26f36b136e4.webp",
    "width": 2604,
    "height": 641
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e4d66-66a2-72e8-b9db-bd17882fe42f.webp",
  "property_secondary_logo_media": {
    "alt_text": "Compass Premier Apartments logo",
    "public_id": "019e4d66-66a2-72e8-b9db-bd17882fe42f",
    "storage_key": "property/5717049565249536/019e4d66-66a2-72e8-b9db-bd17882fe42f.webp",
    "width": 2598,
    "height": 640
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e4d65-f7d2-740c-b3aa-f307071421d0.webp",
  "property_icon_media": {
    "alt_text": "Compass logo on a dark background",
    "public_id": "019e4d65-f7d2-740c-b3aa-f307071421d0",
    "storage_key": "property/5717049565249536/019e4d65-f7d2-740c-b3aa-f307071421d0.webp",
    "width": 1385,
    "height": 1385
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e4d65-f7d2-740c-b3aa-f307071421d0.webp",
  "property_fav_icon_media": {
    "alt_text": "Compass logo on a dark background",
    "public_id": "019e4d65-f7d2-740c-b3aa-f307071421d0",
    "storage_key": "property/5717049565249536/019e4d65-f7d2-740c-b3aa-f307071421d0.webp",
    "width": 1385,
    "height": 1385
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f152a-6f31-74b6-8c99-4d33bc7e4d51.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019f152a-6f31-74b6-8c99-4d33bc7e4d51",
    "storage_key": "property/5717049565249536/019f152a-6f31-74b6-8c99-4d33bc7e4d51.webp",
    "width": 1280,
    "height": 315
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f152a-632b-77ec-9030-6e2e2427942b.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f152a-632b-77ec-9030-6e2e2427942b",
    "storage_key": "property/5717049565249536/019f152a-632b-77ec-9030-6e2e2427942b.webp",
    "width": 1280,
    "height": 315
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#8e8f66",
  "property_secondary_color": "#bec173",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#8e8f66",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "540 - 1078",
  "property_sqft_min": "540",
  "property_sqft_max": "1078",
  "property_price_range": "1270 - 1660",
  "property_price_min": "1270",
  "property_price_max": "1660",
  "property_available_units": 18,
  "property_facebook_url": "https://www.facebook.com/CompassApts",
  "property_instagram_url": "https://www.instagram.com/CompassApartmentsFlorida",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ18sT1g0S3ogR8RCd7Y3Rymc",
  "property_youtube_url": "https://www.youtube.com/@LiveAtCompassApartments",
  "property_yelp_url": "https://www.yelp.com/biz/compass-melbourne",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Everyday ease, built in.</strong> Work out anytime in the 24-hour fitness center, unwind by the pool and sundeck, or take in lakefront views from the gazebo. Lighted tennis and cricket courts, a resident tech lounge with Wi-Fi, package lockers, covered parking, and a car care center keep the day running smoothly—while in-home washers and dryers, spacious closets, screened outdoor space, and select upgraded finishes add comfort where it counts.</p>",
  "property_home_floorplans_blurb": "<p><strong>Floor plans with room to choose.</strong> Explore one- and two-bedroom apartments in Melbourne with open living and dining areas, full-size washer and dryer, generous closets, and screened patios or balconies with extra storage. Select layouts add granite countertops, stainless steel appliances, glass tile backsplash, wood-style plank flooring, and a farmhouse sink with gooseneck faucet.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture life at Compass.</strong> Preview sunlit interiors with large windows, open kitchens with breakfast bars, sleek countertops, and tile backsplash details. Then take in screened outdoor spaces, calm lake views, the lakefront gazebo, a sparkling pool with sundeck seating, fitness center, lounge areas, and outdoor courts—each photo bringing this Melbourne community into sharper focus.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Your Melbourne map starts here.</strong> From Compass, Palm Bay Road and South Babcock Street put coffee, errands, and quick dinners close by, with Florida Tech’s Patterson Botanical Garden for a leafy reset. Head north for Historic Downtown Melbourne dining and events, explore EGAD’s galleries and riverfront spots, or shift gears with beach days, Erna Nixon Park, Space Coast Area Transit stops, and Melbourne Orlando International all within reach.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents have plenty to say about life at Compass.</strong> Reviews often point to the attentive leasing and maintenance teams, with shoutouts for Karen, Nancy, Traci, Augustine, and Manuel. Quiet surroundings, helpful neighbors, prompt service, the fitness center, and covered parking also come up often—along with one simple takeaway: “Compass is a great place to live.”</p>",
  "property_neighborhood_blurb": "<p><strong>Map your Melbourne routine.</strong> From Compass, everyday errands, coffee runs, and quick dinners line up along Palm Bay Road and South Babcock Street, while Florida Tech’s leafy Patterson Botanical Garden adds a quiet green escape close to home. When you want a bigger night out, head north to Historic Downtown Melbourne for New Haven Avenue restaurants, the Henegar Center, and local events, or explore EGAD’s galleries, murals, and riverfront dining around Highland Avenue.</p><p>Beach days, boardwalk strolls at Erna Nixon Park, nearby Space Coast Area Transit stops, and flights from Melbourne Orlando International are all within reach, so your map can shift from practical to playful fast. Start here, then use the interactive map to find your favorite route—or <a href=\"/schedule-a-tour\">schedule a tour</a> and see how Compass connects to the Space Coast.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that make the day feel smoother.</strong> At Compass, the details work together—start with a workout in the 24-hour fitness center, spend a sunny afternoon by the pool and sundeck, or step out to the lakefront gazebo when you want a quieter change of scenery. Lighted tennis and cricket courts, a resident tech lounge with Wi-Fi, package lockers, covered parking, and a car care center add practical convenience without leaving the community.</p><p>Inside your Melbourne apartment, everyday comfort continues with full-size washer and dryer, spacious closets, screened outdoor space with storage, and open kitchens made for easy living. Select homes raise the finish level with granite countertops, stainless steel appliances, glass tile backsplash, wood-style plank flooring, and a farmhouse sink with gooseneck faucet. See the spaces in the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to explore them in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Compass home?</strong> Apply online today for a thoughtfully designed one- or two-bedroom apartment with lakefront ease, full-size washer and dryer, walk-in closets, covered parking, and screened outdoor space—all in a relaxed, connected Melbourne setting.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Connect with the Compass leasing team for help exploring our waterfront Melbourne community, one- and two-bedroom floor plans, and relaxed lakefront setting near Babcock Street and Palm Bay Road. We’re here to make your next step simple.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Compass?</strong> Start here for quick answers about the community, leasing, floor plans, features, and everyday living in this relaxed lakefront setting. If you don’t see what you need, the leasing team is happy to help you find the details and next steps.</p>",
  "property_floorplans_blurb": "<p><strong>Choose the layout that feels right from the first walkthrough.</strong> Compass offers one- and two-bedroom apartment floor plans in Melbourne, giving you options that range from efficient, easy-to-manage spaces to larger two-bath layouts with room to spread out.</p><p>Inside, look for everyday function where it matters most: open living and dining areas, full-size washer and dryer, generous closet space, and a screened patio or balcony with storage that extends your home outdoors. Select floor plans add elevated <a href=\"/amenities\">apartment finishes</a> such as granite countertops, stainless steel appliances, glass tile backsplash, wood-style plank flooring, and a farmhouse sink with gooseneck faucet. Compare current pricing and availability, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see which floor plan matches your next move.</p>",
  "property_gallery_blurb": "<p><strong>See Compass from every angle.</strong> Browse photos that bring the community into focus—from sunlit living rooms with large windows to open kitchens framed by breakfast bars, sleek countertops, and tile backsplash details. Step through images of screened outdoor spaces, calm lake views, and the lakefront gazebo that gives the property its easygoing Melbourne feel.</p><p>The gallery also highlights the places that shape your routine beyond the front door: a sparkling pool with sundeck seating, a bright fitness center, resident lounge spaces, and outdoor courts designed for an active change of scenery. As you look through each photo, imagine how the finishes, views, and shared spaces come together—then compare <a href=\"/floor-plans\">available layouts</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Compass in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Compass from every angle.</strong> Use the interactive map to find available apartments near the community lake, then see how this connected Melbourne location puts everyday routes, recreation, and Space Coast destinations within easy reach.</p>",
  "property_pets_blurb": "<p><strong>Room for paws, whiskers, and easy routines.</strong> At Compass, cats and dogs can settle in with you—up to two per apartment and no weight limit—so your pet search stays simple. Start mornings with leashed strolls around the lakefront setting, let screened outdoor space add a breezy perch, and keep everyday errands easy with pet services and off-leash parks within the Melbourne area. When you’re ready to see how the community fits your routine, explore <a href=\"/amenities\">outdoor spaces and conveniences</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>; the leasing team can review breed guidelines and current policy details.</p>",
  "property_referafriend_blurb": "<p><strong>Share waterfront ease at Compass.</strong> If lake views, relaxed spaces to unwind, and thoughtfully designed one- and two-bedroom homes are what make this community feel right, invite a friend to experience it, too. Send a referral today and let them discover Compass for themselves.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access at Compass.</strong><br>Keep everyday living simple from your connected Melbourne home base. Pay rent, submit maintenance requests, and manage your account online—so you can get back to lakefront ease and the space to unwind.</p>",
  "property_reviews_blurb": "<p><strong>Real feedback from life at Compass.</strong> As you read through resident reviews, you’ll see a clear theme: people appreciate the care they receive from the leasing and maintenance teams. Residents mention friendly, attentive service from team members like Karen, Nancy, Traci, Augustine, and Manuel, with one reviewer calling the staff “nothing short of amazing.”</p><p>Reviews also highlight a quiet atmosphere, helpful neighbors, prompt maintenance attention, and everyday conveniences residents genuinely use—from the fitness center to covered parking. One former resident summed it up simply: “Compass is a great place to live.”</p>",
  "property_created_at": "1752256599944",
  "property_scheduletour_blurb": "<p><strong>See waterfront ease up close.</strong> Tour Compass to take in the lake views, screened outdoor spaces, and thoughtfully designed one- and two-bedroom homes that make everyday unwinding feel effortless. Schedule your visit and picture the rhythm of life here in Melbourne.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you for reaching out to Compass.</strong><br>Your inquiry has been received, and the leasing team will follow up soon. In the meantime, picture waterfront ease in Melbourne—lake views, a resort-inspired pool, a 24-hour fitness center, and thoughtfully designed one- and two-bedroom homes with everyday comforts close at hand.</p>",
  "property_virtualtours_blurb": "<p><strong>Preview the Compass community before you arrive.</strong> The Compass Community virtual tour gives you an easy way to look around from anywhere, so you can get a feel for the lakefront setting, outdoor spaces, and everyday conveniences that shape life at this Melbourne apartment community.</p><p>Move through the experience at your own pace, then use what you see to plan your next step—compare <a href=\"/floor-plans\">one- and two-bedroom layouts</a>, browse more community images in the <a href=\"/gallery\">photo gallery</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> when you’re ready for a closer look in person.</p>",
  "property_copyright": "2025 All Rights Reserved. Compass",
  "property_seo_title_home": "Compass | Apartments in Melbourne, FL",
  "property_seo_description_home": "Discover your perfect apartment at Compass in Melbourne, FL! Choose from our spacious one and two-bedroom floor plans, designed with modern amenities like a fitness center, luxurious pool, and picturesque lake views. Enjoy convenient features such as LUXER package lockers, covered parking, and upscale kitchen islands. With select homes offering walk-in closets and upgraded finishes, your ideal lifestyle awaits. Experience amenities like a tennis court and a relaxing lounge area. Find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in Melbourne, FL",
  "property_seo_description_floorplans": "Discover your ideal living space at Compass in Melbourne, FL! Explore our thoughtfully designed one and two-bedroom floor plans that cater to your lifestyle needs. Browse our available apartment homes today and find the perfect layout for you!",
  "property_seo_title_amenities": "Amenities | Melbourne, FL Apartments for Rent",
  "property_seo_description_amenities": "Discover your ideal lifestyle at Compass in Melbourne, FL! Choose from our spacious one and two-bedroom floor plans, featuring modern amenities like a state-of-the-art fitness center, refreshing pool, and scenic lake views. Enjoy convenience with our LUXER package locker, covered parking, and on-site car wash. Each apartment boasts stylish kitchen islands, walk-in closets, and upgraded paint finishes, perfect for your comfort. Explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in Melbourne, FL",
  "property_seo_description_gallery": "Discover your dream home at Compass in Melbourne, FL! Explore our stunning one- and two-bedroom floor plans, featuring luxurious amenities like a fitness center, pool, tennis court, and a lounge with captivating lake views. Enjoy convenient features such as LUXER Package Lockers, covered parking, and upscale kitchen appliances. Imagine relaxing by the pool or enjoying the outdoors in our beautifully landscaped community. Picture yourself living here and schedule a visit today!",
  "property_seo_title_virtualtours": "Virtual Tours | Compass Apartments",
  "property_seo_description_virtualtours": "\"Explore Compass, your ideal apartment community in Melbourne, FL! Discover our stunning one and two-bedroom floor plans. Take a virtual tour today and envision your new home in a vibrant neighborhood. Click to start your journey!\"",
  "property_seo_title_interactivemap": "Interactive Map | Compass Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Compass in Melbourne, FL! Explore our spacious one- and two-bedroom floor plans featuring luxurious amenities like a fitness center, pool, and tennis court. Enjoy modern kitchen appliances, walk-in closets, and breathtaking lake views. Utilize our convenient LUXER package locker, car wash, and covered parking. Ready to find your perfect apartment? Use our interactive community map to search available units, view pricing, and select your new home today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Melbourne, FL",
  "property_seo_description_neighborhood": "Discover life at Compass in Melbourne, FL! Explore our diverse floor plans featuring charming one and two-bedroom apartments. Visit our Neighborhood page to see what's around our community, including local favorites and nearby points of interest. Your new home awaits—come experience the vibrant lifestyle today!",
  "property_seo_title_contact": "Contact Us | Compass",
  "property_seo_description_contact": "Explore the inviting floor plans at Compass, a premier apartment community in Melbourne, FL. Choose from spacious one or two-bedroom options tailored to fit your lifestyle. Have questions? Contact our leasing team today for more information!",
  "property_seo_title_faqs": "FAQs | Apartments in Melbourne, FL",
  "property_seo_description_faqs": "Discover your perfect home at Compass in Melbourne, FL! Explore our diverse floor plans featuring one and two-bedroom apartments, complete with amenities like a LUXER Package Locker, fitness center, pool, tennis court, and stunning lake views. Enjoy modern touches such as kitchen islands, walk-in closets, and upgraded interiors. Have questions? Browse our FAQs page to find answers about our exceptional community today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Melbourne, FL",
  "property_seo_description_reviews": "Discover the vibrant community at Compass in Melbourne, FL! Explore our stunning one and two-bedroom floor plans, designed with luxurious amenities like a fitness center, pool, and tennis court. Enjoy features such as walk-in closets, kitchen islands, and beautiful lake views. Plus, with conveniences like LUXER package lockers and covered parking, you'll feel right at home. Don't just take our word for it—see what our residents have to say about their experience living here!",
  "property_seo_title_applynow": "Apply Now | Apartments in Melbourne, FL",
  "property_seo_description_applynow": "Discover your perfect home at Compass in Melbourne, FL! Our vibrant community offers spacious one and two-bedroom floor plans, each equipped with modern amenities such as a LUXER Package Locker, outdoor spaces, and stunning lake or pool views. Enjoy resort-style living with a fitness center, tennis court, covered parking, and a refreshing pool. Apply now and find your new apartment with top-notch features like walk-in closets and stylish kitchen islands. Lease online today and start your next adventure at Compass!",
  "property_seo_title_residentaccess": "Resident Access | Compass",
  "property_seo_description_residentaccess": "\"Welcome to Compass in Melbourne, FL! Access your resident portal now to streamline your living experience—pay rent, schedule maintenance, and manage your apartment needs with ease. Join our vibrant community today!\"",
  "property_seo_title_referafriend": "Refer A Friend | Compass",
  "property_seo_description_referafriend": "\"Discover the joy of living at Compass in Melbourne, FL! Refer a friend today and enjoy the perks of great neighbors. Experience our vibrant community and unbeatable amenities. Join us at Compass—where great friends make great neighbors! 🌟\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Compass",
  "property_seo_description_scheduletour": "Discover your dream home at Compass in Melbourne, FL! Schedule a tour of our vibrant apartment community today and explore stunning amenities, spacious layouts, and a welcoming atmosphere that will make you feel right at home. Don’t miss out—book your visit now!",
  "property_seo_title_privacy": "Privacy Policy | Compass",
  "property_seo_description_privacy": "Discover how Compass, your premier apartment community in Melbourne, FL, safeguards your personal information. Our Privacy Policy outlines our commitment to transparency and security. View our privacy policy today to learn more!",
  "property_seo_title_accessibility": "Website Accessibility | Compass",
  "property_seo_description_accessibility": "\"At Compass in Melbourne, FL, we prioritize digital inclusion for all. Discover our Accessibility Statement and learn how we ensure an inviting, accessible experience for every resident and visitor. Join our community where everyone belongs!\"",
  "property_seo_title_sitemap": "Sitemap | Compass",
  "property_seo_description_sitemap": "\"Explore Compass in Melbourne, FL! Discover our sitemap for easy navigation through our vibrant apartment community. Find your perfect home today – click to view!\"",
  "property_seo_title_thankyou": "Thank You | Compass",
  "property_seo_description_thankyou": "Thank you for your interest in Compass Apartments in Melbourne, FL! We appreciate you submitting your information. A member of our team will reach out to you shortly to assist with your apartment search. Explore your new home with us!",
  "property_seo_title_pets": "Pet Policy | Apartments in Summerville, SC\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793651137142",
  "amenities": [
    {
      "id": "custom_95b9a47c-8aec-4b14-9067-8a5fa53311e6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "external_id": "P000000145",
      "title": "LUXER Package Locker",
      "amount": "0.0000",
      "description": "Resident Package Locker",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1230b28b-2cc2-4c72-ac14-c2c816b35aab",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "external_id": "P000000611",
      "title": "Car Wash",
      "amount": "0.0000",
      "description": "Community Car Care Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b3e71a26-6488-4312-80e0-b4860c10c540",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Sleek Granite Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0c7a460a-a608-4561-a1ee-72be09116a62",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "external_id": "P000000623",
      "title": "Covered Parking",
      "amount": "0.0000",
      "description": "Complimentary Covered Parking",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2029c99e-53eb-4686-92f0-913341c78373",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "external_id": "P000000631",
      "title": "Fan",
      "amount": "0.0000",
      "description": "Designer Fans with Remote Controls",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_98ac2f75-cdb7-46e8-a5da-89999c5058a5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "24-Hour Strength & Cardio Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2cc3f792-55df-4bb0-a7af-3f231d93c397",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Wood Style Vinyl Plank Flooring*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4c8ab1e0-1f61-42c1-a3d9-944dce569d50",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_34cb9fbc-bc36-46a5-8891-591c4e5ccee4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "external_id": "P000000652",
      "title": "Kitchen Islands",
      "amount": "0.0000",
      "description": "Spacious Breakfast Bars",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_67b05825-7561-4125-8590-9e0091894e22",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "external_id": "P000000653",
      "title": "Lake",
      "amount": "0.0000",
      "description": "Private Community Lake with Lakefront Gazebo",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bfe4f3f3-aad1-4d27-80cf-dd9f32e1a78b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private, Screened-In Patio or Balcony w/Storage",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e189aabf-570a-4fea-a8d4-d58acd223b22",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Inspired Pool with Sundeck Seating",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6b1c4cc9-8c78-4810-a6db-272c6ffa423f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c60e5929-9917-40ff-9a0f-27c4de18cd23",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "external_id": "P000000676",
      "title": "Sink",
      "amount": "0.0000",
      "description": "Stainless Farmhouse Sink w/ Gooseneck Faucet",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_edf885f5-c857-4036-90bd-b022c9fc2191",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "external_id": "P000000692",
      "title": "Tennis Court",
      "amount": "0.0000",
      "description": "Lighted Tennis & Cricket Courts",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3dcdcb11-695c-4209-8cd1-1c6be4f7559a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "external_id": "P000000695",
      "title": "Tile Backsplash",
      "amount": "0.0000",
      "description": "Glass Tile Backsplash",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d2571257-7538-4000-8315-112b30f45b89",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In-Home Washer and Dryers",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_695e1582-40a2-4299-99a8-3dc4d77c6efb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "external_id": "P000000705",
      "title": "Walk-In Closet",
      "amount": "0.0000",
      "description": "Spacious Closets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f9f73e02-3ed8-4dc3-a608-b6136dd2c2ef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "external_id": "P000001372",
      "title": "Lounge",
      "amount": "0.0000",
      "description": "Resident Tech Lounge with Wi-Fi",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_1f796343-8372-481a-979d-c1abdc4f6163",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-3ef8-73bd-83ec-bf18ae1195e5.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a large sink.",
        "public_id": "019e898e-3ef8-73bd-83ec-bf18ae1195e5",
        "storage_key": "property/5717049565249536/019e898e-3ef8-73bd-83ec-bf18ae1195e5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "View of a stylish kitchen featuring granite countertops, a deep sink, and modern appliances, perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a large sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3836fdee-fb7b-4980-ab70-bfafcb4de6fb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-3dd7-72bc-92e2-dea3f0c502af.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, rowing machine, elliptical, and weight training equipment.",
        "public_id": "019e898e-3dd7-72bc-92e2-dea3f0c502af",
        "storage_key": "property/5717049565249536/019e898e-3dd7-72bc-92e2-dea3f0c502af.webp",
        "width": 2678,
        "height": 1785
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio equipment and weights for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with treadmills, rowing machine, elliptical, and weight training equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e199e7a0-d43c-44a8-b69a-a402ade77cb9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-3b76-746e-8588-5cf643095a5f.webp",
      "image_media": {
        "alt_text": "Modern living room with gray sofa, green accent chair, glass coffee table, and TV console.",
        "public_id": "019e898e-3b76-746e-8588-5cf643095a5f",
        "storage_key": "property/5717049565249536/019e898e-3b76-746e-8588-5cf643095a5f.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Step into a beautifully appointed living space, featuring a comfortable gray sofa, a stylish green accent chair, and a sleek TV console. Perfect for relaxation and entertainment.",
      "link": "",
      "alt_text": "Modern living room with gray sofa, green accent chair, glass coffee table, and TV console.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4b206ded-1573-4d8e-8119-df4e03cd4f20",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-3cef-712d-b6c3-6a9d445e1058.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white vanity, sink, toilet, and bathtub with shower.",
        "public_id": "019e898e-3cef-712d-b6c3-6a9d445e1058",
        "storage_key": "property/5717049565249536/019e898e-3cef-712d-b6c3-6a9d445e1058.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and clean bathroom featuring a spacious vanity with ample storage, a modern sink, a toilet, and a full-size bathtub with a shower.",
      "link": "",
      "alt_text": "Modern bathroom with a white vanity, sink, toilet, and bathtub with shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fd96fa15-4ce7-4e1d-8d4e-4c159c632c63",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-3a41-730a-901e-1e7de5f54fa4.webp",
      "image_media": {
        "alt_text": "Business center with two computers, a printer, and seating.",
        "public_id": "019e898e-3a41-730a-901e-1e7de5f54fa4",
        "storage_key": "property/5717049565249536/019e898e-3a41-730a-901e-1e7de5f54fa4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay connected in our resident business center, equipped with computers and a printer for your convenience.",
      "link": "",
      "alt_text": "Business center with two computers, a printer, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ab3a4483-76d9-496a-bdb2-0708b328ae17",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-3af2-7774-987d-b2411fa8deed.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019e898e-3af2-7774-987d-b2411fa8deed",
        "storage_key": "property/5717049565249536/019e898e-3af2-7774-987d-b2411fa8deed.webp",
        "width": 2620,
        "height": 1747
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush landscaping and comfortable lounge chairs. Perfect for relaxation and fun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f00971ae-de91-4390-b84a-b135bfec1a5b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-3633-715d-8a06-dbc0f57cdd4d.webp",
      "image_media": {
        "alt_text": "Dining area with a table set for two and a stainless steel refrigerator and kitchen counter visible.",
        "public_id": "019e898e-3633-715d-8a06-dbc0f57cdd4d",
        "storage_key": "property/5717049565249536/019e898e-3633-715d-8a06-dbc0f57cdd4d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfortable dining in this apartment's dedicated dining space, adjacent to a modern kitchen with stainless steel appliances.",
      "link": "",
      "alt_text": "Dining area with a table set for two and a stainless steel refrigerator and kitchen counter visible.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_433bcb0a-668c-43ac-8905-964914efa54f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-1da6-75de-bade-9c83a2869408.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with hangers and storage boxes on a shelf.",
        "public_id": "019e898e-1da6-75de-bade-9c83a2869408",
        "storage_key": "property/5717049565249536/019e898e-1da6-75de-bade-9c83a2869408.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample storage with shelving and included hangers. An ideal space for organizing your wardrobe.",
      "link": "",
      "alt_text": "Empty walk-in closet with hangers and storage boxes on a shelf.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_41e2623b-f434-45f9-a7dc-0c91d00aabbb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-1973-772c-8dc3-c557afe5b035.webp",
      "image_media": {
        "alt_text": "Comfortable seating area with a sofa, chairs, coffee table, and TV, adjacent to a business center with computers.",
        "public_id": "019e898e-1973-772c-8dc3-c557afe5b035",
        "storage_key": "property/5717049565249536/019e898e-1973-772c-8dc3-c557afe5b035.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and stay connected in our resident lounge, featuring comfortable seating and a business center with computers.",
      "link": "",
      "alt_text": "Comfortable seating area with a sofa, chairs, coffee table, and TV, adjacent to a business center with computers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f5f79526-54de-43e2-9ae7-439941dbe390",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-1b03-759c-b9c9-1234a4730fbc.webp",
      "image_media": {
        "alt_text": "Modern living room with a gray sofa, glass coffee table, and a glimpse of the kitchen.",
        "public_id": "019e898e-1b03-759c-b9c9-1234a4730fbc",
        "storage_key": "property/5717049565249536/019e898e-1b03-759c-b9c9-1234a4730fbc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish and comfortable living space featuring a sofa, coffee table, and an open-concept kitchen perfect for entertaining.",
      "link": "",
      "alt_text": "Modern living room with a gray sofa, glass coffee table, and a glimpse of the kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6c5742f9-1c91-4785-99c1-e8e7b6e717cd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-2109-71ab-8abd-e00dc51fb4a4.webp",
      "image_media": {
        "alt_text": "Tennis court with buildings in the background.",
        "public_id": "019e898e-2109-71ab-8abd-e00dc51fb4a4",
        "storage_key": "property/5717049565249536/019e898e-2109-71ab-8abd-e00dc51fb4a4.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy a friendly match on our vibrant tennis court, located conveniently near the apartment buildings.",
      "link": "",
      "alt_text": "Tennis court with buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_633803c1-55d5-4fbb-a6cb-6d38f5a0ec48",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-1964-73ae-bc4e-2287ae0dbc6b.webp",
      "image_media": {
        "alt_text": "Stackable washer and dryer next to a bathroom with a vanity, toilet, and mirror.",
        "public_id": "019e898e-1964-73ae-bc4e-2287ae0dbc6b",
        "storage_key": "property/5717049565249536/019e898e-1964-73ae-bc4e-2287ae0dbc6b.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry with a stackable washer and dryer, adjacent to a well-appointed bathroom featuring a modern vanity and ample storage.",
      "link": "",
      "alt_text": "Stackable washer and dryer next to a bathroom with a vanity, toilet, and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_46c333d8-2fee-4ee6-b000-b4772ac928ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-1a8f-7158-bea0-2a3e9eff113b.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and a large wall clock.",
        "public_id": "019e898e-1a8f-7158-bea0-2a3e9eff113b",
        "storage_key": "property/5717049565249536/019e898e-1a8f-7158-bea0-2a3e9eff113b.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, granite countertops, and a decorative wall clock. Perfect for preparing meals.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and a large wall clock.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8f06d372-620a-48f4-b886-31a44325f1bf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-1a97-741d-a3b8-0e02f5c9ca6d.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees",
        "public_id": "019e898e-1a97-741d-a3b8-0e02f5c9ca6d",
        "storage_key": "property/5717049565249536/019e898e-1a97-741d-a3b8-0e02f5c9ca6d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax by the sparkling swimming pool, surrounded by lush landscaping and comfortable lounge chairs.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_abbaaf55-50b3-4a58-9f97-2387a6f9e097",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-1d28-727a-aca3-771c06812bbe.webp",
      "image_media": {
        "alt_text": "King size bed in a modern bedroom with a large window and a ceiling fan.",
        "public_id": "019e898e-1d28-727a-aca3-771c06812bbe",
        "storage_key": "property/5717049565249536/019e898e-1d28-727a-aca3-771c06812bbe.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this spacious bedroom, featuring a king-size bed, ample natural light, and modern decor.",
      "link": "",
      "alt_text": "King size bed in a modern bedroom with a large window and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ebb71cf6-2bc6-4dc8-a11b-c498a9d84016",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-194f-72a9-82b7-5cdbe19f71d9.webp",
      "image_media": {
        "alt_text": "Treadmills, ellipticals, and spin bikes in a modern fitness center.",
        "public_id": "019e898e-194f-72a9-82b7-5cdbe19f71d9",
        "storage_key": "property/5717049565249536/019e898e-194f-72a9-82b7-5cdbe19f71d9.webp",
        "width": 2669,
        "height": 1783
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio machines and free weights for a complete workout.",
      "link": "",
      "alt_text": "Treadmills, ellipticals, and spin bikes in a modern fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9be5a7e9-7aa7-4e6e-af41-0b1dfc109e6e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-1b45-73fa-8308-3d6d716236aa.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with a sidewalk and grassy lawn.",
        "public_id": "019e898e-1b45-73fa-8308-3d6d716236aa",
        "storage_key": "property/5717049565249536/019e898e-1b45-73fa-8308-3d6d716236aa.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Charming apartment buildings with a winding sidewalk through a lush green lawn, offering a welcoming view of the community's exterior.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with a sidewalk and grassy lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a0cfa311-f2da-4f3e-8af3-cf573ab392b2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-02a7-7786-bbcb-0abba9db6808.webp",
      "image_media": {
        "alt_text": "Gazebo with a fountain and pond in the background, surrounded by apartment buildings.",
        "public_id": "019e898e-02a7-7786-bbcb-0abba9db6808",
        "storage_key": "property/5717049565249536/019e898e-02a7-7786-bbcb-0abba9db6808.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy the outdoors with this scenic gazebo overlooking a tranquil pond with a refreshing fountain. Perfect for relaxing and enjoying the beautiful community grounds.",
      "link": "",
      "alt_text": "Gazebo with a fountain and pond in the background, surrounded by apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f22bc50f-6651-44be-9924-890921a7637f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-01af-74de-933a-4842ed38da17.webp",
      "image_media": {
        "alt_text": "Compass Premier Apartments monument sign with landscaping and palm trees.",
        "public_id": "019e898e-01af-74de-933a-4842ed38da17",
        "storage_key": "property/5717049565249536/019e898e-01af-74de-933a-4842ed38da17.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Welcome to Compass Premier Apartments, a beautiful community with lush landscaping and a prominent monument sign. Experience comfortable living in a prime location.",
      "link": "",
      "alt_text": "Compass Premier Apartments monument sign with landscaping and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_557b0297fc2b6d58505fc3f6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Moon River Cafe & Curiosities",
      "poi_type": "Restaurants",
      "poi_address": "728 E New Haven Ave, Melbourne, FL 32901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-3f68-713d-aa72-dd9419f9404e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-3f68-713d-aa72-dd9419f9404e",
        "storage_key": "property/5717049565249536/019f150e-3f68-713d-aa72-dd9419f9404e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.themoonrivercafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10857117253386916749&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "moon-river-cafe--curiosities",
      "poi_latitude": "28.078719",
      "poi_longitude": "-80.6079518",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150f-2e11-7189-9bda-3a6d7d8de5ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-2e11-7189-9bda-3a6d7d8de5ec",
        "storage_key": "property/5717049565249536/019f150f-2e11-7189-9bda-3a6d7d8de5ec.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJVeIf_RUR3ogRjVPkVJ46rJY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "ec_2d29fe819376a72a4f63107f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Mainstreet Pub",
      "poi_type": "Restaurants",
      "poi_address": "705 E New Haven Ave, Melbourne, FL 32901, USA",
      "poi_short_description": "Quaint, vintage spot for casual dining on traditional American & tavern fare, with 3 in-house bars.",
      "poi_long_description": "Quaint, vintage spot for casual dining on traditional American & tavern fare, with 3 in-house bars.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-446b-739d-8f45-c20ad38ec69b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-446b-739d-8f45-c20ad38ec69b",
        "storage_key": "property/5717049565249536/019f150e-446b-739d-8f45-c20ad38ec69b.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "http://www.mymainstreetpub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14659459738187966805&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mainstreet-pub",
      "poi_latitude": "28.0782981",
      "poi_longitude": "-80.6090794",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 321-723-7811",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-0794-71fe-b706-1ef4ab5a4423.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-0794-71fe-b706-1ef4ab5a4423",
        "storage_key": "property/5717049565249536/019f150c-0794-71fe-b706-1ef4ab5a4423.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXYRAwowR3ogRVanVdfbccMs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pub"
    },
    {
      "id": "ec_60c106ba70dd01af3122ca3f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Crush XI Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "923 E New Haven Ave, Melbourne, FL 32901, USA",
      "poi_short_description": "Sharing plates of American & international fare, plus wines, cocktails & craft beer in a hip space.",
      "poi_long_description": "Sharing plates of American & international fare, plus wines, cocktails & craft beer in a hip space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-3c9a-77c3-b63f-d44ce0b7ad35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-3c9a-77c3-b63f-d44ce0b7ad35",
        "storage_key": "property/5717049565249536/019f150e-3c9a-77c3-b63f-d44ce0b7ad35.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.crusheleven.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17040544574899098154&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crush-xi-restaurant",
      "poi_latitude": "28.0782043",
      "poi_longitude": "-80.6052808",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 321-312-6067",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07ad-7176-ad12-467675433227.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07ad-7176-ad12-467675433227",
        "storage_key": "property/5717049565249536/019f150c-07ad-7176-ad12-467675433227.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJe8-fJowR3ogRKhISlgEtfOw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_859e76fcc5e6141c7eb4abed",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Aya Mediterranean Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "936 E New Haven Ave, Melbourne, FL 32901, USA",
      "poi_short_description": "Casual Mediterranean spot featuring kabobs, falafel and gyros, along with lamb and chicken dishes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-37fd-7492-b307-9e0b2588feae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-37fd-7492-b307-9e0b2588feae",
        "storage_key": "property/5717049565249536/019f150e-37fd-7492-b307-9e0b2588feae.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://ayamediterranean.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11524705412171438514&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aya-mediterranean-cuisine",
      "poi_latitude": "28.0784856",
      "poi_longitude": "-80.6048786",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 321-327-7061",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07ad-7176-ad12-467675433227.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07ad-7176-ad12-467675433227",
        "storage_key": "property/5717049565249536/019f150c-07ad-7176-ad12-467675433227.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJH3z67KAR3ogRshmACYP6758",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_81de7ff1d5d60a9229bf46c3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Ember & Oak",
      "poi_type": "Restaurants",
      "poi_address": "712 E New Haven Ave, Melbourne, FL 32901, USA",
      "poi_short_description": "Contemporary venue dishing up steaks, seafood, pastas & wine, plus live music & a courtyard lounge.",
      "poi_long_description": "Contemporary venue dishing up steaks, seafood, pastas & wine, plus live music & a courtyard lounge.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-3409-7228-ba80-97d61e560870.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-3409-7228-ba80-97d61e560870",
        "storage_key": "property/5717049565249536/019f150e-3409-7228-ba80-97d61e560870.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://emberandoak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1092941317505186936&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ember--oak",
      "poi_latitude": "28.0786356",
      "poi_longitude": "-80.60871",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 321-722-6285",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07ad-7176-ad12-467675433227.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07ad-7176-ad12-467675433227",
        "storage_key": "property/5717049565249536/019f150c-07ad-7176-ad12-467675433227.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN6g1eUQR3ogReHw-blboKg8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "ec_5890140a29c4677181e22b5c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Meg O’Malley's Restaurant & Irish Pub",
      "poi_type": "Restaurants",
      "poi_address": "812 E New Haven Ave, Melbourne, FL 32901, USA",
      "poi_short_description": "Irish pub, eatery and bar providing staples like fish and chips and shepherd's pie as well as a full bar.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150b-d566-70be-a16e-baa999b0c240.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-d566-70be-a16e-baa999b0c240",
        "storage_key": "property/5717049565249536/019f150b-d566-70be-a16e-baa999b0c240.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.megomalleys.com/?y_source=1_MjI1NzMwOTktNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9635962277486891816&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meg-omalleys-restaurant--irish-pub",
      "poi_latitude": "28.0787286",
      "poi_longitude": "-80.6072509",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 321-952-5510",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07ad-7176-ad12-467675433227.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07ad-7176-ad12-467675433227",
        "storage_key": "property/5717049565249536/019f150c-07ad-7176-ad12-467675433227.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2QdwWowR3ogRKJOrSqPQuYU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_b7eb6828bd0dbc2ab5866477",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Jao Thai Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "914 W New Haven Ave, Melbourne, FL 32901, USA",
      "poi_short_description": "Easygoing strip-mall venue offering a menu of curries, noodles & other Thai dishes in low-key digs.",
      "poi_long_description": "Easygoing strip-mall venue offering a menu of curries, noodles & other Thai dishes in low-key digs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-3839-713c-9bef-985c73ec6ff6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-3839-713c-9bef-985c73ec6ff6",
        "storage_key": "property/5717049565249536/019f150e-3839-713c-9bef-985c73ec6ff6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.jaothaikitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4292672237925978984&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jao-thai-kitchen",
      "poi_latitude": "28.0790742",
      "poi_longitude": "-80.6369344",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 321-914-0708",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07ad-7176-ad12-467675433227.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07ad-7176-ad12-467675433227",
        "storage_key": "property/5717049565249536/019f150c-07ad-7176-ad12-467675433227.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiaj-5gMO3ogRaFPCJqiikjs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "ec_fdd0b9b00eb1b26238789d27",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Cantina Louie (Melbourne, FL)",
      "poi_type": "Restaurants",
      "poi_address": "2400 Dairy Rd, West Melbourne, FL 32904, USA",
      "poi_short_description": "Casual restaurant and bar dishing up Mexican street fare plus creative cocktails.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-37fd-7492-b307-a1cb2cb0e11d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-37fd-7492-b307-a1cb2cb0e11d",
        "storage_key": "property/5717049565249536/019f150e-37fd-7492-b307-a1cb2cb0e11d.webp",
        "width": 1280,
        "height": 577
      },
      "poi_business_url": "https://cantinalouie.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4020694932841877858&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cantina-louie-melbourne-fl",
      "poi_latitude": "28.0730803",
      "poi_longitude": "-80.6383714",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 321-345-4719",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07ad-7176-ad12-467675433227.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07ad-7176-ad12-467675433227",
        "storage_key": "property/5717049565249536/019f150c-07ad-7176-ad12-467675433227.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL8ZUzKkP3ogRYtFAJr1gzDc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_34136d243dcb82ff8fc623f7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Agave D'Oro Mexican Bar and Grill",
      "poi_type": "Restaurants",
      "poi_address": "3955 W New Haven Ave, West Melbourne, FL 32904, USA",
      "poi_short_description": "Relaxed dining room serving familiar Mexican eats as well as cocktails, margaritas and beers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-3edf-73ec-bf5c-434438dd57e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-3edf-73ec-bf5c-434438dd57e9",
        "storage_key": "property/5717049565249536/019f150e-3edf-73ec-bf5c-434438dd57e9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.agavedoromexicanbarandgrill.online/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6025482200835733220&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "agave-doro-mexican-bar-and-grill",
      "poi_latitude": "28.078329",
      "poi_longitude": "-80.6900349",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 321-327-3501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07ad-7176-ad12-467675433227.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07ad-7176-ad12-467675433227",
        "storage_key": "property/5717049565249536/019f150c-07ad-7176-ad12-467675433227.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJad7CdCAP3ogR5LZAJSPQnlM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_ba5e2102197b302c664d2601",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Chart House",
      "poi_type": "Restaurants",
      "poi_address": "2250 Front St, Melbourne, FL 32901, USA",
      "poi_short_description": "High-end chain eatery serving seafood & steakhouse fare in a classy setting with views.",
      "poi_long_description": "High-end chain eatery serving seafood & steakhouse fare in a classy setting with views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-35fb-771b-9003-046276453d78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-35fb-771b-9003-046276453d78",
        "storage_key": "property/5717049565249536/019f150e-35fb-771b-9003-046276453d78.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.chart-house.com/location/chart-house-melbourne-fl/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7794632089517676705&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chart-house",
      "poi_latitude": "28.0765259",
      "poi_longitude": "-80.5991093",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 321-729-6558",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07ad-7176-ad12-467675433227.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07ad-7176-ad12-467675433227",
        "storage_key": "property/5717049565249536/019f150c-07ad-7176-ad12-467675433227.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSzCXdo8R3ogRodiPcpYYLGw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_c603421fab398c72c57e1262",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Squid Lips",
      "poi_type": "Restaurants",
      "poi_address": "1477 Pineapple Ave, Melbourne, FL 32935, USA",
      "poi_short_description": "Chill eatery serving uniquely prepared seafood, including bacon-wrapped scallops & smoked fish dip.",
      "poi_long_description": "Chill eatery serving uniquely prepared seafood, including bacon-wrapped scallops & smoked fish dip.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150b-d510-711e-ab03-bc8d5a7c1358.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-d510-711e-ab03-bc8d5a7c1358",
        "storage_key": "property/5717049565249536/019f150b-d510-711e-ab03-bc8d5a7c1358.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "http://www.squidlipsgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2967694236063990326&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "squid-lips",
      "poi_latitude": "28.1315025",
      "poi_longitude": "-80.6253898",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 321-259-3101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07ad-7176-ad12-467675433227.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07ad-7176-ad12-467675433227",
        "storage_key": "property/5717049565249536/019f150c-07ad-7176-ad12-467675433227.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTzPvvyUQ3ogRNoKRJi9eLyk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_fabce500694f1a451622f033",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Marker 99 Restaurant & Lounge",
      "poi_type": "Restaurants",
      "poi_address": "4263 US-1, Melbourne, FL 32935, USA",
      "poi_short_description": "Seafood and surf-'n-turf grill showcasing Latin eats, craft cocktails and waterfront views in a casual atmosphere.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-3dbd-731e-adea-f754c024973f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-3dbd-731e-adea-f754c024973f",
        "storage_key": "property/5717049565249536/019f150e-3dbd-731e-adea-f754c024973f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://marker99restaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4377734155077223497&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marker-99-restaurant--lounge",
      "poi_latitude": "28.17695",
      "poi_longitude": "-80.648076",
      "poi_miles_from_property": "9.1 mi",
      "poi_walking_minutes": "3 hours 22 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 321-253-1369",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07ad-7176-ad12-467675433227.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07ad-7176-ad12-467675433227",
        "storage_key": "property/5717049565249536/019f150c-07ad-7176-ad12-467675433227.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX9JSRlsF3ogRSQR5EgXWwDw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fusion_restaurant"
    },
    {
      "id": "ec_85930bf58d8d77c509d3c368",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Coasters Pub & Biergarten.",
      "poi_type": "Restaurants",
      "poi_address": "971 E Eau Gallie Blvd A, Melbourne, FL 32937, USA",
      "poi_short_description": "Sports-centric alehouse with a hearty American menu & 100+ beers, including many craft brews.",
      "poi_long_description": "Sports-centric alehouse with a hearty American menu & 100+ beers, including many craft brews.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-3f5b-7645-b670-80b84d980d1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-3f5b-7645-b670-80b84d980d1b",
        "storage_key": "property/5717049565249536/019f150e-3f5b-7645-b670-80b84d980d1b.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://www.facebook.com/CoastersPub/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13133575580567578184&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "coasters-pub--biergarten",
      "poi_latitude": "28.137157",
      "poi_longitude": "-80.584062",
      "poi_miles_from_property": "8.6 mi",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 321-779-2739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-0794-71fe-b706-1ef4ab5a4423.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-0794-71fe-b706-1ef4ab5a4423",
        "storage_key": "property/5717049565249536/019f150c-0794-71fe-b706-1ef4ab5a4423.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTXxYlfQQ3ogRSKZ55mfVQ7Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gastropub"
    },
    {
      "id": "ec_5114eb6e541cb45fce67481b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Mustard's Famous Hot Dogs",
      "poi_type": "Restaurants",
      "poi_address": "1288 N Harbor City Blvd, Melbourne, FL 32935, USA",
      "poi_short_description": "Lively hot dog eatery featuring toppings with a Chicago slant in casual surrounds with outdoor seating.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-45f6-768c-ae81-ce19e38ea4f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-45f6-768c-ae81-ce19e38ea4f1",
        "storage_key": "property/5717049565249536/019f150e-45f6-768c-ae81-ce19e38ea4f1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.mustardslaststand.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8650183875955818527&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mustards-famous-hot-dogs",
      "poi_latitude": "28.1279944",
      "poi_longitude": "-80.6305823",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 321-254-5776",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07ad-7176-ad12-467675433227.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07ad-7176-ad12-467675433227",
        "storage_key": "property/5717049565249536/019f150c-07ad-7176-ad12-467675433227.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3zVGUCgQ3ogRH4AokGegC3g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hot_dog_restaurant"
    },
    {
      "id": "ec_717a3c92332fe36ab7327a1e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "El Ambia Cubano Cuban Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "950 E Melbourne Ave, Melbourne, FL 32901, USA",
      "poi_short_description": "Familiar Cuban eats are dished out in this unfussy cafe where the barstools are made from congas.",
      "poi_long_description": "Familiar Cuban eats are dished out in this unfussy cafe where the barstools are made from congas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-50ea-759e-bd5e-5d0b2e952d28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-50ea-759e-bd5e-5d0b2e952d28",
        "storage_key": "property/5717049565249536/019f150e-50ea-759e-bd5e-5d0b2e952d28.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.elambiacubano.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13795941790653893095&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-ambia-cubano-cuban-restaurant",
      "poi_latitude": "28.0772258",
      "poi_longitude": "-80.60458129999999",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 321-327-8389",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07ad-7176-ad12-467675433227.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07ad-7176-ad12-467675433227",
        "storage_key": "property/5717049565249536/019f150c-07ad-7176-ad12-467675433227.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl_1IpI4R3ogR50nk7fYHdb8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cuban_restaurant"
    },
    {
      "id": "ec_1ae7e208022ed5c31c0a9d9b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Publix Super Market at Melbourne Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "1411 S Babcock St, Melbourne, FL 32901, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-50fa-774d-88d8-a39cb7414a4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-50fa-774d-88d8-a39cb7414a4c",
        "storage_key": "property/5717049565249536/019f150e-50fa-774d-88d8-a39cb7414a4c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=704&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=10098785954744754714&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-melbourne-shopping-center",
      "poi_latitude": "28.0866101",
      "poi_longitude": "-80.61999039999999",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 321-727-8085",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07cf-74a8-8a92-368a45bd7869.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07cf-74a8-8a92-368a45bd7869",
        "storage_key": "property/5717049565249536/019f150c-07cf-74a8-8a92-368a45bd7869.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4RzOgOUR3ogRGuJD91EYJow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_0c1a0eeed1e03a8aa1de461c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "3550 S Babcock St, Melbourne, FL 32901, USA",
      "poi_short_description": "Discount store carrying groceries and home goods, along with a pharmacy and bakery, with self checkouts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-521e-743e-9fc8-2da7429112fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-521e-743e-9fc8-2da7429112fa",
        "storage_key": "property/5717049565249536/019f150e-521e-743e-9fc8-2da7429112fa.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.walmart.com/store/5366-melbourne-fl/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=15788131475000332272&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "28.0553398",
      "poi_longitude": "-80.6232174",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 321-723-8988",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07cf-74a8-8a92-368a45bd7869.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07cf-74a8-8a92-368a45bd7869",
        "storage_key": "property/5717049565249536/019f150c-07cf-74a8-8a92-368a45bd7869.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJizsKFQ4S3ogR8A-Pau21Gts",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_25d0a27b173e92353a4a78e1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "CVS",
      "poi_type": "Shopping & Retail",
      "poi_address": "15 E New Haven Ave, Melbourne, FL 32901, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-5721-74c3-885f-29fb3b6b7b71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-5721-74c3-885f-29fb3b6b7b71",
        "storage_key": "property/5717049565249536/019f150e-5721-74c3-885f-29fb3b6b7b71.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cvs.com/store-locator/melbourne-fl-pharmacies/15-e-new-haven-avenue-melbourne-fl-32901/storeid=5439?WT.mc_id=LS_GOOGLE_FS_5439",
      "poi_directions_map_url": "https://maps.google.com/?cid=9050334512672635071&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "28.0781764",
      "poi_longitude": "-80.6208095",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 321-409-3941",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07d1-72b8-8cf6-7908daa237e7",
        "storage_key": "property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWeu4uvAR3ogRv3hP3kk_mX0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_c7936ae153487bc5957940d5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "975 S Babcock St, Melbourne, FL 32901, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-5796-732c-a72b-47d2add296e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-5796-732c-a72b-47d2add296e3",
        "storage_key": "property/5717049565249536/019f150e-5796-732c-a72b-47d2add296e3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-975+s+babcock+st-melbourne-fl-32901/id=3080",
      "poi_directions_map_url": "https://maps.google.com/?cid=13229345586189045931&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "28.0938484",
      "poi_longitude": "-80.62115059999999",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 321-723-4664",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07d1-72b8-8cf6-7908daa237e7",
        "storage_key": "property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJedMJFquqPoYRqxCu87cTmLc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_9636d449cc4de5842220e653",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "3998 S Babcock St, Melbourne, FL 32901, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-5bf4-7029-afe3-83df8387e57f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-5bf4-7029-afe3-83df8387e57f",
        "storage_key": "property/5717049565249536/019f150e-5bf4-7029-afe3-83df8387e57f.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.7-eleven.com/locations/fl/melbourne/3998-s-babcock-st-41184?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=1148308925123815128&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "28.0501241",
      "poi_longitude": "-80.622068",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 321-334-7329",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150f-2e78-7750-9f96-b799191d8ba3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-2e78-7750-9f96-b799191d8ba3",
        "storage_key": "property/5717049565249536/019f150f-2e78-7750-9f96-b799191d8ba3.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJvT4-sGoT3ogR2GZqJuKc7w8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_ba1a5c6aba23a2f5935a9b9c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "bealls",
      "poi_type": "Shopping & Retail",
      "poi_address": "1401 S Babcock St, Melbourne, FL 32901, USA",
      "poi_short_description": "Department store stocking home goods & an assortment of apparel, shoes & accessories for all ages.",
      "poi_long_description": "Department store stocking home goods & an assortment of apparel, shoes & accessories for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-5ea8-74de-ae44-b83b53279252.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-5ea8-74de-ae44-b83b53279252",
        "storage_key": "property/5717049565249536/019f150e-5ea8-74de-ae44-b83b53279252.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://stores.bealls.com/fl/melbourne/1401-s-babcock-st",
      "poi_directions_map_url": "https://maps.google.com/?cid=4320274290403610706&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bealls",
      "poi_latitude": "28.0868676",
      "poi_longitude": "-80.6200733",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 321-956-9066",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-0798-74c8-8baa-21c0e8c7e052.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-0798-74c8-8baa-21c0e8c7e052",
        "storage_key": "property/5717049565249536/019f150c-0798-74c8-8baa-21c0e8c7e052.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJo7AGE-8R3ogRUpDCy5Oy9Ds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "ec_a33fa5c6db8391ac77704333",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Melbourne Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "1355 S Babcock St, Melbourne, FL 32901, USA",
      "poi_short_description": "Unfussy shopping strip with grocer, services & discount stores for clothing & other goods.",
      "poi_long_description": "Unfussy shopping strip with grocer, services & discount stores for clothing & other goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-558b-741f-b7e9-49bbaea682a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-558b-741f-b7e9-49bbaea682a5",
        "storage_key": "property/5717049565249536/019f150e-558b-741f-b7e9-49bbaea682a5.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=928828369233746218&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "melbourne-shopping-center",
      "poi_latitude": "28.0872827",
      "poi_longitude": "-80.6212776",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-0798-74c8-8baa-21c0e8c7e052.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-0798-74c8-8baa-21c0e8c7e052",
        "storage_key": "property/5717049565249536/019f150c-0798-74c8-8baa-21c0e8c7e052.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ6R2Ubu8R3ogRKpl7DXvc4ww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_a83697b3b50130abc7959b75",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Prime Care Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "1509 S Babcock St #3033, Melbourne, FL 32901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-659f-7219-b34d-d70d94b58364.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-659f-7219-b34d-d70d94b58364",
        "storage_key": "property/5717049565249536/019f150e-659f-7219-b34d-d70d94b58364.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://primecare-pharmacy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11940754810164817562&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prime-care-pharmacy",
      "poi_latitude": "28.0846081",
      "poi_longitude": "-80.6211883",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 321-586-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150f-2e6b-709c-89be-c796d20e7e44.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-2e6b-709c-89be-c796d20e7e44",
        "storage_key": "property/5717049565249536/019f150f-2e6b-709c-89be-c796d20e7e44.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWY9O8-8R3ogRmi7pKTwVtqU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_bd4a85148f1ce4be39532db9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Thrifty DIscount Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "32 W New Haven Ave, Melbourne, FL 32901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-5610-707d-b6b7-8c4e84dee907.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-5610-707d-b6b7-8c4e84dee907",
        "storage_key": "property/5717049565249536/019f150e-5610-707d-b6b7-8c4e84dee907.webp",
        "width": 1182,
        "height": 756
      },
      "poi_business_url": "https://discountpharmaciesoffl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12863651185754922073&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thrifty-discount-pharmacy",
      "poi_latitude": "28.0789688",
      "poi_longitude": "-80.6226111",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 321-676-5999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150f-2e6b-709c-89be-c796d20e7e44.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-2e6b-709c-89be-c796d20e7e44",
        "storage_key": "property/5717049565249536/019f150f-2e6b-709c-89be-c796d20e7e44.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFdKobPoR3ogRWVx0UZnehLI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_0fd77a4a4e20cc68ef247f1f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "550 E Eau Gallie Blvd, Melbourne, FL 32937, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-7800-77db-b415-ff5c2e265eb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-7800-77db-b415-ff5c2e265eb6",
        "storage_key": "property/5717049565249536/019f150e-7800-77db-b415-ff5c2e265eb6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/melbourne/550-e-eau-gallie-blvd/2701805?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=17018384860834582208&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "28.138588",
      "poi_longitude": "-80.591228",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 321-779-8192",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150f-2e78-7750-9f96-b799191d8ba3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-2e78-7750-9f96-b799191d8ba3",
        "storage_key": "property/5717049565249536/019f150f-2e78-7750-9f96-b799191d8ba3.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJl5n4LF4Q3ogRwE7uGN1yLew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_6cae000e81339156dc0f39be",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "University Park Elementary School",
      "poi_type": "Education",
      "poi_address": "500 W University Blvd, Melbourne, FL 32901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-72e2-7229-a0bf-95f4ad270bef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-72e2-7229-a0bf-95f4ad270bef",
        "storage_key": "property/5717049565249536/019f150e-72e2-7229-a0bf-95f4ad270bef.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.brevardschools.org/UniversityParkES",
      "poi_directions_map_url": "https://maps.google.com/?cid=11169820037781972224&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-park-elementary-school",
      "poi_latitude": "28.063063",
      "poi_longitude": "-80.6297529",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 321-723-2566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-0797-7161-8652-f8c3b5e1f301.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-0797-7161-8652-f8c3b5e1f301",
        "storage_key": "property/5717049565249536/019f150c-0797-7161-8652-f8c3b5e1f301.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJtZx3UwYS3ogRAOUI5SQsA5s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_fcde78c55d235b33a0019e70",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Stone Magnet Middle School",
      "poi_type": "Education",
      "poi_address": "1101 E University Blvd, Melbourne, FL 32901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.brevardschools.org/StoneMS",
      "poi_directions_map_url": "https://maps.google.com/?cid=4407483346083659272&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stone-magnet-middle-school",
      "poi_latitude": "28.063264",
      "poi_longitude": "-80.60316759999999",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 321-723-0741",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-0797-7161-8652-f8c3b5e1f301.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-0797-7161-8652-f8c3b5e1f301",
        "storage_key": "property/5717049565249536/019f150c-0797-7161-8652-f8c3b5e1f301.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmXdhVyQS3ogRCD7EXMCGKj0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_094b2da0204bda9536a7f612",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Palm Bay High School",
      "poi_type": "Education",
      "poi_address": "101 Pirate Ln, Melbourne, FL 32901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-8b96-77cc-8f6a-d5f794523894.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-8b96-77cc-8f6a-d5f794523894",
        "storage_key": "property/5717049565249536/019f150e-8b96-77cc-8f6a-d5f794523894.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.brevardschools.org/PalmbayHS",
      "poi_directions_map_url": "https://maps.google.com/?cid=8795314266258370309&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "palm-bay-high-school",
      "poi_latitude": "28.0479352",
      "poi_longitude": "-80.6164876",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 321-952-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-0797-7161-8652-f8c3b5e1f301.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-0797-7161-8652-f8c3b5e1f301",
        "storage_key": "property/5717049565249536/019f150c-0797-7161-8652-f8c3b5e1f301.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJs7B3NBMS3ogRBW9BwLk7D3o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_cd02a5ee16f1a72ba5e0be7c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Melbourne High School",
      "poi_type": "Education",
      "poi_address": "74 Bulldog Blvd, Melbourne, FL 32901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-8608-750a-a11a-5d940022f109.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-8608-750a-a11a-5d940022f109",
        "storage_key": "property/5717049565249536/019f150e-8608-750a-a11a-5d940022f109.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.brevardschools.org/MelbourneHS",
      "poi_directions_map_url": "https://maps.google.com/?cid=15662552705314099482&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "melbourne-high-school",
      "poi_latitude": "28.09072",
      "poi_longitude": "-80.619652",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 321-952-5880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-0797-7161-8652-f8c3b5e1f301.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-0797-7161-8652-f8c3b5e1f301",
        "storage_key": "property/5717049565249536/019f150c-0797-7161-8652-f8c3b5e1f301.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2_Au7-gR3ogRGpEUpLOQXNk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_1c7c0fbfebd9f6b7c69a10da",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Melbourne Central Catholic High School",
      "poi_type": "Education",
      "poi_address": "154 E Florida Ave, Melbourne, FL 32901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-b86e-76ae-87ce-0df8cb1222ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-b86e-76ae-87ce-0df8cb1222ba",
        "storage_key": "property/5717049565249536/019f150e-b86e-76ae-87ce-0df8cb1222ba.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://melbournecc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=419392350640997603&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "melbourne-central-catholic-high-school",
      "poi_latitude": "28.0578926",
      "poi_longitude": "-80.6169942",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 321-727-0793",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-0797-7161-8652-f8c3b5e1f301.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-0797-7161-8652-f8c3b5e1f301",
        "storage_key": "property/5717049565249536/019f150c-0797-7161-8652-f8c3b5e1f301.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJO1wbwhAS3ogR4wR58R770QU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_e1ee9c12200019e1927a578e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Holy Trinity Episcopal Academy - Lower School",
      "poi_type": "Education",
      "poi_address": "1720 Peachtree St, Melbourne, FL 32901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-8558-7338-a3c6-899922ed22c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-8558-7338-a3c6-899922ed22c2",
        "storage_key": "property/5717049565249536/019f150e-8558-7338-a3c6-899922ed22c2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.htacademy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3302863796159277930&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "holy-trinity-episcopal-academy---lower-school",
      "poi_latitude": "28.0809628",
      "poi_longitude": "-80.6231521",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 321-723-8323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-0797-7161-8652-f8c3b5e1f301.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-0797-7161-8652-f8c3b5e1f301",
        "storage_key": "property/5717049565249536/019f150c-0797-7161-8652-f8c3b5e1f301.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJw1fzXvoR3ogRamuSjx8h1i0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_1cd1f2d29111684f230f8d51",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Bright Horizons Academy",
      "poi_type": "Education",
      "poi_address": "550 E Florida Ave, Melbourne, FL 32901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-7209-754b-9cee-b75342eabf16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-7209-754b-9cee-b75342eabf16",
        "storage_key": "property/5717049565249536/019f150e-7209-754b-9cee-b75342eabf16.webp",
        "width": 650,
        "height": 432
      },
      "poi_business_url": "http://brighthorizonsacademy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5071051805202279270&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bright-horizons-academy",
      "poi_latitude": "28.0573528",
      "poi_longitude": "-80.6125347",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 321-312-1663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-0797-7161-8652-f8c3b5e1f301.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-0797-7161-8652-f8c3b5e1f301",
        "storage_key": "property/5717049565249536/019f150c-0797-7161-8652-f8c3b5e1f301.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV3_PuhcS3ogRZmuvzr_-X0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_86969c21aa853c7c69cfbcfd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Florida Institute of Technology",
      "poi_type": "Education",
      "poi_address": "150 W University Blvd, Melbourne, FL 32901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150b-db96-7538-96c8-44b3cbdc70b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-db96-7538-96c8-44b3cbdc70b6",
        "storage_key": "property/5717049565249536/019f150b-db96-7538-96c8-44b3cbdc70b6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.floridatech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4015618102034841365&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "florida-institute-of-technology",
      "poi_latitude": "28.0639632",
      "poi_longitude": "-80.621455",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 321-674-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-0797-7161-8652-f8c3b5e1f301.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-0797-7161-8652-f8c3b5e1f301",
        "storage_key": "property/5717049565249536/019f150c-0797-7161-8652-f8c3b5e1f301.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ96ZS_AQS3ogRFT9qXWNXujc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_5be255b0ba27451de80359be",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Florida Preparatory Academy (Florida Prep)",
      "poi_type": "Education",
      "poi_address": "1950 Academy Drive, 326 W New Haven Ave, Melbourne, FL 32901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-9c5f-72f8-a446-a76e375e7113.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-9c5f-72f8-a446-a76e375e7113",
        "storage_key": "property/5717049565249536/019f150e-9c5f-72f8-a446-a76e375e7113.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.flprep.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5908723258173141652&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "florida-preparatory-academy-florida-prep",
      "poi_latitude": "28.0795412",
      "poi_longitude": "-80.62808969999999",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-0797-7161-8652-f8c3b5e1f301.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-0797-7161-8652-f8c3b5e1f301",
        "storage_key": "property/5717049565249536/019f150c-0797-7161-8652-f8c3b5e1f301.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJyyeTRfwR3ogRlLJ_X38AAFI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_a7ec9d1c900cb85ad4a31db1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Sunshine Early Childhood Center",
      "poi_type": "Education",
      "poi_address": "2802 Lipscomb St, Melbourne, FL 32901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9192047502509664243&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunshine-early-childhood-center",
      "poi_latitude": "28.0664701",
      "poi_longitude": "-80.6049827",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07d1-72b8-8cf6-7908daa237e7",
        "storage_key": "property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQJjMyES3ogR8-eagYC2kH8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "point_of_interest"
    },
    {
      "id": "ec_a4a05f9e181cf6a04d4b9657",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Premiere Theaters Oaks 10",
      "poi_type": "Entertainment",
      "poi_address": "1800 W Hibiscus Blvd, Melbourne, FL 32901, USA",
      "poi_short_description": "Clean movie theater with a vintage feel.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-928d-73aa-8eca-6d79ddc4fa86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-928d-73aa-8eca-6d79ddc4fa86",
        "storage_key": "property/5717049565249536/019f150e-928d-73aa-8eca-6d79ddc4fa86.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.oaks10.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11332137626787113187&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "premiere-theaters-oaks-10",
      "poi_latitude": "28.0862971",
      "poi_longitude": "-80.6522888",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 321-953-3388",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150f-2e6e-7759-9484-5ac2f22c2f58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-2e6e-7759-9484-5ac2f22c2f58",
        "storage_key": "property/5717049565249536/019f150f-2e6e-7759-9484-5ac2f22c2f58.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJWdJGihIO3ogR4-h7niHXQ50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_46b2aad6e074c05e42f6d87d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Henegar Center For the Arts",
      "poi_type": "Entertainment",
      "poi_address": "625 E New Haven Ave #119, Melbourne, FL 32901, USA",
      "poi_short_description": "Expansive, proscenium-style stage for musicals & more with a mirrored dance studio & art exhibits.",
      "poi_long_description": "Expansive, proscenium-style stage for musicals & more with a mirrored dance studio & art exhibits.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-9791-7453-aa69-1cd9ec9aeb79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-9791-7453-aa69-1cd9ec9aeb79",
        "storage_key": "property/5717049565249536/019f150e-9791-7453-aa69-1cd9ec9aeb79.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.henegarcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6024634720706584977&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "henegar-center-for-the-arts",
      "poi_latitude": "28.0781009",
      "poi_longitude": "-80.61024669999999",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 321-723-8698",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07d1-72b8-8cf6-7908daa237e7",
        "storage_key": "property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe7mvNPMR3ogRkWEzzVvNm1M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_e2ae14b545066c8f1923788f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Maxwell C. King Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "3865 N Wickham Rd, Melbourne, FL 32935, USA",
      "poi_short_description": "Modern venue hosts bands, musicals, comedy shows & other all-ages performances in an intimate space.",
      "poi_long_description": "Modern venue hosts bands, musicals, comedy shows & other all-ages performances in an intimate space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-91b1-731f-a85f-26305af62d24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-91b1-731f-a85f-26305af62d24",
        "storage_key": "property/5717049565249536/019f150e-91b1-731f-a85f-26305af62d24.webp",
        "width": 1280,
        "height": 943
      },
      "poi_business_url": "http://www.kingcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3025395646644299614&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maxwell-c-king-center-for-the-performing-arts",
      "poi_latitude": "28.1705878",
      "poi_longitude": "-80.669401",
      "poi_miles_from_property": "10.2 mi",
      "poi_walking_minutes": "3 hours 46 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 321-242-2219",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07d1-72b8-8cf6-7908daa237e7",
        "storage_key": "property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzUvSA34F3ogRXic_t09d_Ck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_e4fc4bb09b36d54390369853",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Iron Oak Post",
      "poi_type": "Entertainment",
      "poi_address": "2023 Melbourne Ct, Melbourne, FL 32901, USA",
      "poi_short_description": "Easygoing spot pouring draft beers from a long line of taps, also offering live music & trivia.",
      "poi_long_description": "Easygoing spot pouring draft beers from a long line of taps, also offering live music & trivia.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-94d2-7359-b383-c1a06ca26e1c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-94d2-7359-b383-c1a06ca26e1c",
        "storage_key": "property/5717049565249536/019f150e-94d2-7359-b383-c1a06ca26e1c.webp",
        "width": 959,
        "height": 487
      },
      "poi_business_url": "https://ironoakpost.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12734169992243438382&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "iron-oak-post",
      "poi_latitude": "28.0778332",
      "poi_longitude": "-80.6053335",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 321-327-8356",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-0794-71fe-b706-1ef4ab5a4423.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-0794-71fe-b706-1ef4ab5a4423",
        "storage_key": "property/5717049565249536/019f150c-0794-71fe-b706-1ef4ab5a4423.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJUhAIowR3ogRLuMbsSPcuLA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_933314fb22c7195836d3cb9f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Debauchery",
      "poi_type": "Entertainment",
      "poi_address": "807 E New Haven Ave, Melbourne, FL 32901, USA",
      "poi_short_description": "Unpretentious bar & live-music venue featuring an extensive craft beer selection & pool tables.",
      "poi_long_description": "Unpretentious bar & live-music venue featuring an extensive craft beer selection & pool tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-a93c-7060-8a26-6149f74d74ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-a93c-7060-8a26-6149f74d74ba",
        "storage_key": "property/5717049565249536/019f150e-a93c-7060-8a26-6149f74d74ba.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://debauchery.bravesites.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5698665337875584231&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "debauchery",
      "poi_latitude": "28.0783323",
      "poi_longitude": "-80.6073148",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 321-821-4914",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-0794-71fe-b706-1ef4ab5a4423.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-0794-71fe-b706-1ef4ab5a4423",
        "storage_key": "property/5717049565249536/019f150c-0794-71fe-b706-1ef4ab5a4423.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw_bCW4wR3ogR59Tnle65FU8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_f3d56335a37a5fdf7c1580a9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Mainstreet Pub",
      "poi_type": "Entertainment",
      "poi_address": "705 E New Haven Ave, Melbourne, FL 32901, USA",
      "poi_short_description": "Quaint, vintage spot for casual dining on traditional American & tavern fare, with 3 in-house bars.",
      "poi_long_description": "Quaint, vintage spot for casual dining on traditional American & tavern fare, with 3 in-house bars.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-446b-739d-8f45-c20ad38ec69b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-446b-739d-8f45-c20ad38ec69b",
        "storage_key": "property/5717049565249536/019f150e-446b-739d-8f45-c20ad38ec69b.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "http://www.mymainstreetpub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14659459738187966805&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mainstreet-pub",
      "poi_latitude": "28.0782981",
      "poi_longitude": "-80.6090794",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 321-723-7811",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-0794-71fe-b706-1ef4ab5a4423.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-0794-71fe-b706-1ef4ab5a4423",
        "storage_key": "property/5717049565249536/019f150c-0794-71fe-b706-1ef4ab5a4423.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXYRAwowR3ogRVanVdfbccMs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pub"
    },
    {
      "id": "ec_45dbdc66d3398d7fffcf6ab5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Brevard Zoo",
      "poi_type": "Entertainment",
      "poi_address": "8225 N Wickham Rd, Melbourne, FL 32940, USA",
      "poi_short_description": "Attractions include 500+ animals, a chance to feed giraffes, zip-lining & a kids' water play area.",
      "poi_long_description": "Attractions include 500+ animals, a chance to feed giraffes, zip-lining & a kids' water play area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-c4f6-7697-a412-dc928c4c76fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-c4f6-7697-a412-dc928c4c76fc",
        "storage_key": "property/5717049565249536/019f150e-c4f6-7697-a412-dc928c4c76fc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.brevardzoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5323358647013922720&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brevard-zoo",
      "poi_latitude": "28.2249886",
      "poi_longitude": "-80.7138556",
      "poi_miles_from_property": "16.1 mi",
      "poi_walking_minutes": "5 hours 52 mins",
      "poi_biking_minutes": "1 hour 26 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 321-254-9453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07d1-72b8-8cf6-7908daa237e7",
        "storage_key": "property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI0Ja3y4E3ogRoNdEL3xe4Ek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "ec_568517947950a0e7cd9f7178",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Gleason Performing Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "2943 Science Cir, Melbourne, FL 32901, USA",
      "poi_short_description": "University-affiliated venue staging theater productions, lectures, concerts and other events.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-af77-71df-85c1-d8c19f23fb0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-af77-71df-85c1-d8c19f23fb0d",
        "storage_key": "property/5717049565249536/019f150e-af77-71df-85c1-d8c19f23fb0d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.fit.edu/gleason/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5800664294824578582&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gleason-performing-arts-center",
      "poi_latitude": "28.064698",
      "poi_longitude": "-80.6233024",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 321-674-8006",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07d1-72b8-8cf6-7908daa237e7",
        "storage_key": "property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEYdClAQS3ogRFo5PYnEZgFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_da93d4dc581ffc8fc49a2bbe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Rossetter House Museum Office",
      "poi_type": "Entertainment",
      "poi_address": "1320 Highland Ave, Melbourne, FL 32935, USA",
      "poi_short_description": "Guided tours of the early-1900s private home & gardens of a prominent local resident.",
      "poi_long_description": "Guided tours of the early-1900s private home & gardens of a prominent local resident.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150b-e23c-73c6-bb47-b15b79489e9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-e23c-73c6-bb47-b15b79489e9b",
        "storage_key": "property/5717049565249536/019f150b-e23c-73c6-bb47-b15b79489e9b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rossetterhousemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15819060041167113074&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rossetter-house-museum-office",
      "poi_latitude": "28.1285407",
      "poi_longitude": "-80.62631879999999",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 321-254-9855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-079b-751f-80fb-0f372a2bb1e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-079b-751f-80fb-0f372a2bb1e8",
        "storage_key": "property/5717049565249536/019f150c-079b-751f-80fb-0f372a2bb1e8.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJZaW0QC8Q3ogRcotXYkuXiNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_c01e975311c525ac117b8928",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Blind Lion Jazz, Blues and Comedy Club",
      "poi_type": "Entertainment",
      "poi_address": "101 Harrison St, Cocoa, FL 32922, USA",
      "poi_short_description": "Cozy venue featuring live music from jazz to blues and burgers plus comedy shows.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-bc60-70ee-8bd0-d76f024b1d1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-bc60-70ee-8bd0-d76f024b1d1d",
        "storage_key": "property/5717049565249536/019f150e-bc60-70ee-8bd0-d76f024b1d1d.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://blindlionjazzandblues.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17497552101638931868&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blind-lion-jazz-blues-and-comedy-club",
      "poi_latitude": "28.3548713",
      "poi_longitude": "-80.725582",
      "poi_miles_from_property": "22.6 mi",
      "poi_walking_minutes": "8 hours 14 mins",
      "poi_biking_minutes": "2 hours 15 mins",
      "poi_driving_minutes": "39 mins",
      "poi_business_phone": "+1 321-877-3456",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07d1-72b8-8cf6-7908daa237e7",
        "storage_key": "property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOx-eCrYB3ogRnAUUMe7K0_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_b09aeee27f16582488724609",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Health First's Holmes Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1350 Hickory St, Melbourne, FL 32901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150b-f2fe-7330-aa00-f9e5f06bce29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-f2fe-7330-aa00-f9e5f06bce29",
        "storage_key": "property/5717049565249536/019f150b-f2fe-7330-aa00-f9e5f06bce29.webp",
        "width": 1280,
        "height": 843
      },
      "poi_business_url": "https://hf.org/healthcare-home/location-directory/holmes-regional-medical-center#about-this-location-",
      "poi_directions_map_url": "https://maps.google.com/?cid=12601849543310100390&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "health-firsts-holmes-regional-medical-center",
      "poi_latitude": "28.0874342",
      "poi_longitude": "-80.6143731",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 321-434-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07d3-76ea-ac84-1e17b11a0c8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07d3-76ea-ac84-1e17b11a0c8f",
        "storage_key": "property/5717049565249536/019f150c-07d3-76ea-ac84-1e17b11a0c8f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJh-lRY-wR3ogRpsfqZWTD4q4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_588f6813a2b4b0e7fc7abb05",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Health First AdventHealth Centra Care Gateway",
      "poi_type": "Health and Wellness",
      "poi_address": "1223 Gateway Dr #1E, Melbourne, FL 32901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-c4f5-71e9-8c3c-3baac729fb45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-c4f5-71e9-8c3c-3baac729fb45",
        "storage_key": "property/5717049565249536/019f150e-c4f5-71e9-8c3c-3baac729fb45.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://centracare.adventhealth.com/urgent-care/brevard/gateway-melbourne",
      "poi_directions_map_url": "https://maps.google.com/?cid=11583246488682545990&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "health-first-adventhealth-centra-care-gateway",
      "poi_latitude": "28.0893768",
      "poi_longitude": "-80.6494263",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 321-473-6658",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07d1-72b8-8cf6-7908daa237e7",
        "storage_key": "property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwfCFQtoP3ogRRsO2j0_1v6A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_a17d50d79b0c1cf77fe0d49c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Melbourne Downtown MedFast Urgent Care | Walk In Clinic | Emergency Quick Care",
      "poi_type": "Health and Wellness",
      "poi_address": "206 E New Haven Ave, Melbourne, FL 32901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-d92f-73a0-8c62-03934dadb282.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-d92f-73a0-8c62-03934dadb282",
        "storage_key": "property/5717049565249536/019f150e-d92f-73a0-8c62-03934dadb282.webp",
        "width": 1280,
        "height": 914
      },
      "poi_business_url": "http://www.medfastcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1642211098265985299&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "melbourne-downtown-medfast-urgent-care--walk-in-clinic--emergency-quick-care",
      "poi_latitude": "28.0790575",
      "poi_longitude": "-80.6176452",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 321-802-3311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07d1-72b8-8cf6-7908daa237e7",
        "storage_key": "property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsYKkE_ER3ogREyFZBktOyhY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_17b9ac9d388de3a73aad1ee7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "15 E New Haven Ave, Melbourne, FL 32901, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-5721-74c3-885f-29fb3b6b7b71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-5721-74c3-885f-29fb3b6b7b71",
        "storage_key": "property/5717049565249536/019f150e-5721-74c3-885f-29fb3b6b7b71.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cvs.com/store-locator/melbourne-fl-pharmacies/15-e-new-haven-avenue-melbourne-fl-32901/storeid=5439?WT.mc_id=LS_GOOGLE_FS_5439",
      "poi_directions_map_url": "https://maps.google.com/?cid=9050334512672635071&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "28.0781764",
      "poi_longitude": "-80.6208095",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 321-409-3941",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07d1-72b8-8cf6-7908daa237e7",
        "storage_key": "property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWeu4uvAR3ogRv3hP3kk_mX0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_8c760d0e5a6f6bf17e1d2535",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "975 S Babcock St, Melbourne, FL 32901, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-5796-732c-a72b-47d2add296e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-5796-732c-a72b-47d2add296e3",
        "storage_key": "property/5717049565249536/019f150e-5796-732c-a72b-47d2add296e3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-975+s+babcock+st-melbourne-fl-32901/id=3080",
      "poi_directions_map_url": "https://maps.google.com/?cid=13229345586189045931&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "28.0938484",
      "poi_longitude": "-80.62115059999999",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 321-723-4664",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07d1-72b8-8cf6-7908daa237e7",
        "storage_key": "property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJedMJFquqPoYRqxCu87cTmLc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_9852ca5cc0292156f0254b96",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Thrifty DIscount Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "32 W New Haven Ave, Melbourne, FL 32901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-5610-707d-b6b7-8c4e84dee907.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-5610-707d-b6b7-8c4e84dee907",
        "storage_key": "property/5717049565249536/019f150e-5610-707d-b6b7-8c4e84dee907.webp",
        "width": 1182,
        "height": 756
      },
      "poi_business_url": "https://discountpharmaciesoffl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12863651185754922073&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thrifty-discount-pharmacy",
      "poi_latitude": "28.0789688",
      "poi_longitude": "-80.6226111",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 321-676-5999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150f-2e6b-709c-89be-c796d20e7e44.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-2e6b-709c-89be-c796d20e7e44",
        "storage_key": "property/5717049565249536/019f150f-2e6b-709c-89be-c796d20e7e44.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFdKobPoR3ogRWVx0UZnehLI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_9f5cfb2eaf69db2567e25ef0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4454 Hollywood Blvd, West Melbourne, FL 32904, USA",
      "poi_short_description": "Clean gym, featuring a pool, a sauna and basketball courts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150b-ea68-70a8-8084-40643d470773.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-ea68-70a8-8084-40643d470773",
        "storage_key": "property/5717049565249536/019f150b-ea68-70a8-8084-40643d470773.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=1111&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=5454078697010086834&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "28.0370148",
      "poi_longitude": "-80.6537975",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 321-373-0049",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07d1-72b8-8cf6-7908daa237e7",
        "storage_key": "property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxS-5qJkN3ogRssNPkK3HsEs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_845ca361e5eb1e2d8c5e6fa5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1555 W New Haven Ave, West Melbourne, FL 32904, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150b-e94b-7761-85a0-00c8db5a35d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-e94b-7761-85a0-00c8db5a35d8",
        "storage_key": "property/5717049565249536/019f150b-e94b-7761-85a0-00c8db5a35d8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/west-melbourne-fl?utm_medium=yext&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=10245988145469213914&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "28.0771162",
      "poi_longitude": "-80.6476923",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 321-329-6290",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07d1-72b8-8cf6-7908daa237e7",
        "storage_key": "property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjTJNqfMP3ogR2kyOx-4PMY4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_7650e1cdba01dd3a15cf9bff",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Fitness Society Supplements",
      "poi_type": "Health and Wellness",
      "poi_address": "1717 S Babcock St #103, Melbourne, FL 32901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-c605-7065-97ef-595057f35f22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-c605-7065-97ef-595057f35f22",
        "storage_key": "property/5717049565249536/019f150e-c605-7065-97ef-595057f35f22.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.fitnesssocietysupplements.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18127952771978886396&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fitness-society-supplements",
      "poi_latitude": "28.0813877",
      "poi_longitude": "-80.6209655",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 321-676-8165",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-0798-74c8-8baa-21c0e8c7e052.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-0798-74c8-8baa-21c0e8c7e052",
        "storage_key": "property/5717049565249536/019f150c-0798-74c8-8baa-21c0e8c7e052.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJUYwCw7sR3ogR_PzbBgBtk_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "ec_b4305ed37bcdb3424d7a7014",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "The Yoga Space",
      "poi_type": "Health and Wellness",
      "poi_address": "17 E Melbourne Ave, Melbourne, FL 32901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://theyogaspacemelbourne.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7712178986211461049&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-yoga-space",
      "poi_latitude": "28.0761981",
      "poi_longitude": "-80.6208211",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 321-223-4285",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-0797-7161-8652-f8c3b5e1f301.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-0797-7161-8652-f8c3b5e1f301",
        "storage_key": "property/5717049565249536/019f150c-0797-7161-8652-f8c3b5e1f301.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJm0BbQ_cR3ogRucddVe0pB2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_f621c813152ca3f795320763",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Bean Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1208 E Melbourne Ave, Melbourne, FL 32901, USA",
      "poi_short_description": "Quaint, waterfront park offering 2 picnic pavilions & BBQs along with walkways & benches.",
      "poi_long_description": "Quaint, waterfront park offering 2 picnic pavilions & BBQs along with walkways & benches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-d182-7558-8015-67194f7ad903.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-d182-7558-8015-67194f7ad903",
        "storage_key": "property/5717049565249536/019f150e-d182-7558-8015-67194f7ad903.webp",
        "width": 1000,
        "height": 498
      },
      "poi_business_url": "https://www.melbourneflorida.org/Home/Components/FacilityDirectory/FacilityDirectory/60/1539",
      "poi_directions_map_url": "https://maps.google.com/?cid=5146787127779075636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bean-park",
      "poi_latitude": "28.078314",
      "poi_longitude": "-80.6017277",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 321-953-6230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07bd-70e8-a655-5c90745f4731.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07bd-70e8-a655-5c90745f4731",
        "storage_key": "property/5717049565249536/019f150c-07bd-70e8-a655-5c90745f4731.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJIWOwBI8R3ogRNCbTtZ8PbUc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_d1e87cdde3dc5cb336efecce",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Crane Creek Promenade",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "990 E Melbourne Ave, Melbourne, FL 32901, USA",
      "poi_short_description": "Famous viewing point for observing manatees as well as site of interpretative mammal exhibits.",
      "poi_long_description": "Famous viewing point for observing manatees as well as site of interpretative mammal exhibits.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-e686-720c-9e96-351a7515e53c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-e686-720c-9e96-351a7515e53c",
        "storage_key": "property/5717049565249536/019f150e-e686-720c-9e96-351a7515e53c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3479564075137919111&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crane-creek-promenade",
      "poi_latitude": "28.0772484",
      "poi_longitude": "-80.6031704",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07bd-70e8-a655-5c90745f4731.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07bd-70e8-a655-5c90745f4731",
        "storage_key": "property/5717049565249536/019f150c-07bd-70e8-a655-5c90745f4731.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJGQf5w44R3ogRh2jOPxflSTA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_3ac898534b99fe40d7c1cc15",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Riverview Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2301-2499 Irwin St, Melbourne, FL 32901, USA",
      "poi_short_description": "Waterfront rec area, featuring covered picnic tables, a dog park, jungle gym and more.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-e6de-77e5-80be-db7c9f66cdac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-e6de-77e5-80be-db7c9f66cdac",
        "storage_key": "property/5717049565249536/019f150e-e6de-77e5-80be-db7c9f66cdac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.melbourneflorida.org/Home/Components/FacilityDirectory/FacilityDirectory/50/1539?npage=2",
      "poi_directions_map_url": "https://maps.google.com/?cid=10660442595722250641&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverview-park",
      "poi_latitude": "28.0729477",
      "poi_longitude": "-80.5999842",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 321-608-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07bd-70e8-a655-5c90745f4731.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07bd-70e8-a655-5c90745f4731",
        "storage_key": "property/5717049565249536/019f150c-07bd-70e8-a655-5c90745f4731.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJlfpqfYgR3ogRkcl3Mg-A8ZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_2d8c2b37abdc1f0c4f297697",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Kiwanis Park at Geiger Point",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1313 Melbourne Causeway, Melbourne, FL 32901, USA",
      "poi_short_description": "Small, 7-acre park on the Indian River Lagoon featuring a paved walkway, picnic areas, and fishing.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-e0fe-75ad-b169-0481e4b01ccc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-e0fe-75ad-b169-0481e4b01ccc",
        "storage_key": "property/5717049565249536/019f150e-e0fe-75ad-b169-0481e4b01ccc.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://brevardfl.gov/ParksAndRecreation/ParksByCity/ParksInMelbourne/Kiwanis",
      "poi_directions_map_url": "https://maps.google.com/?cid=12355331346690103161&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kiwanis-park-at-geiger-point",
      "poi_latitude": "28.0820034",
      "poi_longitude": "-80.5960887",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 321-255-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07bd-70e8-a655-5c90745f4731.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07bd-70e8-a655-5c90745f4731",
        "storage_key": "property/5717049565249536/019f150c-07bd-70e8-a655-5c90745f4731.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9w2UKZsR3ogReVe2AWb0dqs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_65f047251456df07ab766940",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Claude Edge Front St. Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2205 Front St, Melbourne, FL 32901, USA",
      "poi_short_description": "Waterfront hangout with a boat launch, fishing pier & picnic tables, plus a gazebo for events.",
      "poi_long_description": "Waterfront hangout with a boat launch, fishing pier & picnic tables, plus a gazebo for events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-d3c5-714c-864a-a1b7f5b42294.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-d3c5-714c-864a-a1b7f5b42294",
        "storage_key": "property/5717049565249536/019f150e-d3c5-714c-864a-a1b7f5b42294.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3167456464213035161&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "claude-edge-front-st-park",
      "poi_latitude": "28.0789881",
      "poi_longitude": "-80.6000607",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 321-608-7260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07bd-70e8-a655-5c90745f4731.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07bd-70e8-a655-5c90745f4731",
        "storage_key": "property/5717049565249536/019f150c-07bd-70e8-a655-5c90745f4731.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6VqNnI8R3ogRmcjuTt8Q9Ss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_81024707eee39fde0bf80f9e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Ballard Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "924 Thomas Barbour Dr, Melbourne, FL 32935, USA",
      "poi_short_description": "Riverfront park with sport courts, boat ramps, a playground & picnic facilities.",
      "poi_long_description": "Riverfront park with sport courts, boat ramps, a playground & picnic facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-e680-77cc-879e-53547b1d02df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-e680-77cc-879e-53547b1d02df",
        "storage_key": "property/5717049565249536/019f150e-e680-77cc-879e-53547b1d02df.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.melbourneflorida.org/departments/parks-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=3196459742219984286&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ballard-park",
      "poi_latitude": "28.1247476",
      "poi_longitude": "-80.6249955",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 321-255-4608",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07bd-70e8-a655-5c90745f4731.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07bd-70e8-a655-5c90745f4731",
        "storage_key": "property/5717049565249536/019f150c-07bd-70e8-a655-5c90745f4731.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJUZJohy4Q3ogRnt3bMTMbXCw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_925270ddcf5e78edca57f1a2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Fee Avenue Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "118 E Fee Ave, Melbourne, FL 32901, USA",
      "poi_short_description": "Recreational park featuring an outdoor swimming pool with a slide, plus several playgrounds.",
      "poi_long_description": "Recreational park featuring an outdoor swimming pool with a slide, plus several playgrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-f7bb-725b-8c62-49a47694a6ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-f7bb-725b-8c62-49a47694a6ad",
        "storage_key": "property/5717049565249536/019f150e-f7bb-725b-8c62-49a47694a6ad.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.melbourneflorida.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10757935635215332131&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fee-avenue-park",
      "poi_latitude": "28.0833598",
      "poi_longitude": "-80.6189768",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 321-608-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07bd-70e8-a655-5c90745f4731.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07bd-70e8-a655-5c90745f4731",
        "storage_key": "property/5717049565249536/019f150c-07bd-70e8-a655-5c90745f4731.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_-v1MvAR3ogRI7OGVXbdS5U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_7befd4ebdd9ac5becbef52b7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Joe Mullins Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Chaffee St, Melbourne, FL 32901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-e73e-7538-a383-da7319ac6eab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-e73e-7538-a383-da7319ac6eab",
        "storage_key": "property/5717049565249536/019f150e-e73e-7538-a383-da7319ac6eab.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5136905540129146221&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joe-mullins-park",
      "poi_latitude": "28.0452332",
      "poi_longitude": "-80.61514480000001",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07bd-70e8-a655-5c90745f4731.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07bd-70e8-a655-5c90745f4731",
        "storage_key": "property/5717049565249536/019f150c-07bd-70e8-a655-5c90745f4731.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJbc_UCmsS3ogRbUUiTF_0SUc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_4e38ede34d306bfa62d4e824",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Melbourne Military Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1601 Oak St, Melbourne, FL 32901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-f246-76f8-aa5b-43bba222771e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-f246-76f8-aa5b-43bba222771e",
        "storage_key": "property/5717049565249536/019f150e-f246-76f8-aa5b-43bba222771e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://brevardfl.gov/ParksAndRecreation/ParksByCity/ParksInMerrittIsland/VeteransMemorial",
      "poi_directions_map_url": "https://maps.google.com/?cid=2548291615152664815&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "melbourne-military-memorial-park",
      "poi_latitude": "28.0837349",
      "poi_longitude": "-80.61415339999999",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 321-953-6230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07bd-70e8-a655-5c90745f4731.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07bd-70e8-a655-5c90745f4731",
        "storage_key": "property/5717049565249536/019f150c-07bd-70e8-a655-5c90745f4731.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJR8q1ke0R3ogR7_BH-bhZXSM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_4dd3153bc9bf17c97643bc84",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Canova Beach Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3299 N Hwy A1A, Indian Harbour Beach, FL 32937, USA",
      "poi_short_description": "Dogs on leashes are allowed at this beach park with a picnic pavilion, showers & restrooms.",
      "poi_long_description": "Dogs on leashes are allowed at this beach park with a picnic pavilion, showers & restrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-fac5-7440-a5a1-eaa51cbe76dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-fac5-7440-a5a1-eaa51cbe76dc",
        "storage_key": "property/5717049565249536/019f150e-fac5-7440-a5a1-eaa51cbe76dc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.brevardfl.gov/ParksAndRecreation/ParkDirectory/Canova",
      "poi_directions_map_url": "https://maps.google.com/?cid=7025160928374212571&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "canova-beach-park",
      "poi_latitude": "28.1387107",
      "poi_longitude": "-80.5802976",
      "poi_miles_from_property": "8.7 mi",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 321-255-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07bd-70e8-a655-5c90745f4731.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07bd-70e8-a655-5c90745f4731",
        "storage_key": "property/5717049565249536/019f150c-07bd-70e8-a655-5c90745f4731.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6zowKPMQ3ogR28eyuaRifmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_eb6a7f1bba0fa3a0e8953b59",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Melbourne Orlando International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Air Terminal Pkwy, Melbourne, FL 32901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150b-fd4f-763e-9209-5a96fcb05195.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-fd4f-763e-9209-5a96fcb05195",
        "storage_key": "property/5717049565249536/019f150b-fd4f-763e-9209-5a96fcb05195.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mlbair.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10996310418774269143&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "melbourne-orlando-international-airport",
      "poi_latitude": "28.1012659",
      "poi_longitude": "-80.645078",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 321-723-6227",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07d1-72b8-8cf6-75389503df15.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07d1-72b8-8cf6-75389503df15",
        "storage_key": "property/5717049565249536/019f150c-07d1-72b8-8cf6-75389503df15.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJtzLs29gR3ogR15z3nhC-mpg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_bd3c3e82d5f7c72205e31cd5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Space Coast Area Transit",
      "poi_type": "Transportation & Transit",
      "poi_address": "460 S Harbor City Blvd, Melbourne, FL 32901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-ff11-74e9-85fd-35a962900106.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-ff11-74e9-85fd-35a962900106",
        "storage_key": "property/5717049565249536/019f150e-ff11-74e9-85fd-35a962900106.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://321transit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=441536893667044856&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "space-coast-area-transit",
      "poi_latitude": "28.1005032",
      "poi_longitude": "-80.6139194",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07d1-72b8-8cf6-7908daa237e7",
        "storage_key": "property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRye818YR3ogR-O1AJnenIAY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_f7a5b9c34eaf1c624452bcda",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Greyhound: Bus Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "4520 W New Haven Ave, Melbourne, FL 32904, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150f-156f-75cf-afa6-90cb302b9dd4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-156f-75cf-afa6-90cb302b9dd4",
        "storage_key": "property/5717049565249536/019f150f-156f-75cf-afa6-90cb302b9dd4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.greyhound.com/en-us/bus-station-470987",
      "poi_directions_map_url": "https://maps.google.com/?cid=83228213412508812&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-bus-station",
      "poi_latitude": "28.0791761",
      "poi_longitude": "-80.7023851",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 321-723-4323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07d1-72b8-8cf6-7908daa237e7",
        "storage_key": "property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKTscFt4R3ogRjDS-f56vJwE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_8f86c8e53b8105a584a081ba",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "W Eau Gallie Blvd, Melbourne, FL 32934, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150f-18eb-762f-911d-2bf3133f893c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-18eb-762f-911d-2bf3133f893c",
        "storage_key": "property/5717049565249536/019f150f-18eb-762f-911d-2bf3133f893c.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13924351275386328797&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "park--ride",
      "poi_latitude": "28.1207518",
      "poi_longitude": "-80.71330859999999",
      "poi_miles_from_property": "9.8 mi",
      "poi_walking_minutes": "3 hours 37 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150f-2ece-70db-bbff-2e8e080b4c76.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-2ece-70db-bbff-2e8e080b4c76",
        "storage_key": "property/5717049565249536/019f150f-2ece-70db-bbff-2e8e080b4c76.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJx1yWrtkO3ogR3dYo6bU7PcE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_6517a9333445b28fde81ffa7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Palm Bay Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "341 Emerson Dr NW, Palm Bay, FL 32907, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://321transit.com/vanpool-park-ride/palm-bay-park-ride-lot/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11032621160382539964&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "palm-bay-park--ride",
      "poi_latitude": "28.0323124",
      "poi_longitude": "-80.6807613",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 321-633-1878",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150f-2ece-70db-bbff-2e8e080b4c76.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-2ece-70db-bbff-2e8e080b4c76",
        "storage_key": "property/5717049565249536/019f150f-2ece-70db-bbff-2e8e080b4c76.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJrwH6TFQM3ogRvCgP9n2-G5k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_c4a3012a5bf7639d5602561a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Viera",
      "poi_type": "Transportation & Transit",
      "poi_address": "5545 Porada Dr, Rockledge, FL 32955, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17981409177874895154&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "viera",
      "poi_latitude": "28.2655066",
      "poi_longitude": "-80.7378688",
      "poi_miles_from_property": "18.7 mi",
      "poi_walking_minutes": "6 hours 51 mins",
      "poi_biking_minutes": "1 hour 47 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 321-952-4563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150f-2ece-70db-bbff-2e8e080b4c76.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-2ece-70db-bbff-2e8e080b4c76",
        "storage_key": "property/5717049565249536/019f150f-2ece-70db-bbff-2e8e080b4c76.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6c8MqUwB3ogRMpEusGDMivk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "ec_08184218dbd260656017887d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "L3Harris Technologies Corporate Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1025 W NASA Blvd Bldg A, Melbourne, FL 32919, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150f-103e-757f-922e-2ce45a292fb0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-103e-757f-922e-2ce45a292fb0",
        "storage_key": "property/5717049565249536/019f150f-103e-757f-922e-2ce45a292fb0.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://www.l3harris.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9762691640534636460&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "l3harris-technologies-corporate-headquarters",
      "poi_latitude": "28.0923174",
      "poi_longitude": "-80.637964",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 321-727-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07d1-72b8-8cf6-7908daa237e7",
        "storage_key": "property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8dSUm_gP3ogRrBe-dVIMfIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_3c1ff9012e377c3b0e136c6f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "NORTHROP GRUMMAN",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2000 W NASA Blvd, Melbourne, FL 32904, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://northropgrumman.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16422209183934606948&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northrop-grumman",
      "poi_latitude": "28.0974835",
      "poi_longitude": "-80.6505746",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 321-951-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07d1-72b8-8cf6-7908daa237e7",
        "storage_key": "property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDZz1b2gO3ogRZG6Ugz5o5-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_c206643aedd3379e9e751b88",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Florida Institute of Technology",
      "poi_type": "Major Employers & Offices",
      "poi_address": "150 W University Blvd, Melbourne, FL 32901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150b-db96-7538-96c8-44b3cbdc70b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-db96-7538-96c8-44b3cbdc70b6",
        "storage_key": "property/5717049565249536/019f150b-db96-7538-96c8-44b3cbdc70b6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.floridatech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4015618102034841365&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "florida-institute-of-technology",
      "poi_latitude": "28.0639632",
      "poi_longitude": "-80.621455",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 321-674-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-0797-7161-8652-f8c3b5e1f301.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-0797-7161-8652-f8c3b5e1f301",
        "storage_key": "property/5717049565249536/019f150c-0797-7161-8652-f8c3b5e1f301.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ96ZS_AQS3ogRFT9qXWNXujc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_a89a614c2995ce19b87988de",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Health First's Holmes Regional Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1350 Hickory St, Melbourne, FL 32901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150b-f2fe-7330-aa00-f9e5f06bce29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-f2fe-7330-aa00-f9e5f06bce29",
        "storage_key": "property/5717049565249536/019f150b-f2fe-7330-aa00-f9e5f06bce29.webp",
        "width": 1280,
        "height": 843
      },
      "poi_business_url": "https://hf.org/healthcare-home/location-directory/holmes-regional-medical-center#about-this-location-",
      "poi_directions_map_url": "https://maps.google.com/?cid=12601849543310100390&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "health-firsts-holmes-regional-medical-center",
      "poi_latitude": "28.0874342",
      "poi_longitude": "-80.6143731",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 321-434-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07d3-76ea-ac84-1e17b11a0c8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07d3-76ea-ac84-1e17b11a0c8f",
        "storage_key": "property/5717049565249536/019f150c-07d3-76ea-ac84-1e17b11a0c8f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJh-lRY-wR3ogRpsfqZWTD4q4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_f7693f2e3902e7e4ec6b6113",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Orlando Health Melbourne Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "250 N Wickham Rd, Melbourne, FL 32935, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150b-f316-719d-be48-7a104d23148d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-f316-719d-be48-7a104d23148d",
        "storage_key": "property/5717049565249536/019f150b-f316-719d-be48-7a104d23148d.webp",
        "width": 1080,
        "height": 864
      },
      "poi_business_url": "https://www.orlandohealth.com/facilities/melbourne-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=5395501980447306260&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orlando-health-melbourne-hospital",
      "poi_latitude": "28.1095255",
      "poi_longitude": "-80.6751025",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 321-752-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07d3-76ea-ac84-1e17b11a0c8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07d3-76ea-ac84-1e17b11a0c8f",
        "storage_key": "property/5717049565249536/019f150c-07d3-76ea-ac84-1e17b11a0c8f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJhYfQMlgO3ogRFHJ68Xas4Eo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_ac3784eca6a76427b5fef860",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Melbourne Orlando International Airport",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Air Terminal Pkwy, Melbourne, FL 32901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150b-fd4f-763e-9209-5a96fcb05195.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-fd4f-763e-9209-5a96fcb05195",
        "storage_key": "property/5717049565249536/019f150b-fd4f-763e-9209-5a96fcb05195.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mlbair.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10996310418774269143&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "melbourne-orlando-international-airport",
      "poi_latitude": "28.1012659",
      "poi_longitude": "-80.645078",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 321-723-6227",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07d1-72b8-8cf6-75389503df15.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07d1-72b8-8cf6-75389503df15",
        "storage_key": "property/5717049565249536/019f150c-07d1-72b8-8cf6-75389503df15.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJtzLs29gR3ogR15z3nhC-mpg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_af9be981a7460f816199b5ce",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Patrick Space Force Base",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1224 S Patrick Dr, Patrick Space Force Base, FL 32925, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150f-0d87-713c-8ac2-03fddf4debb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-0d87-713c-8ac2-03fddf4debb1",
        "storage_key": "property/5717049565249536/019f150f-0d87-713c-8ac2-03fddf4debb1.webp",
        "width": 960,
        "height": 898
      },
      "poi_business_url": "https://www.patrick.spaceforce.mil/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15343007700322136972&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "patrick-space-force-base",
      "poi_latitude": "28.2181377",
      "poi_longitude": "-80.60301199999999",
      "poi_miles_from_property": "13.4 mi",
      "poi_walking_minutes": "4 hours 54 mins",
      "poi_biking_minutes": "1 hour 33 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "+1 321-799-1300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-0a42-7581-8ae0-ba13d9aad641.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-0a42-7581-8ae0-ba13d9aad641",
        "storage_key": "property/5717049565249536/019f150c-0a42-7581-8ae0-ba13d9aad641.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo477Xhkb3ogRjLPIczZQ7dQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_abdcfccfa86c6a5b0db3f667",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Terran Orbital Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 Rialto Pl 2nd Floor, Melbourne, FL 32901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://terranorbital.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10765877833742962024&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "terran-orbital-corporation",
      "poi_latitude": "28.0900697",
      "poi_longitude": "-80.6251468",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 855-862-5527",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-07d1-72b8-8cf6-7908daa237e7",
        "storage_key": "property/5717049565249536/019f150c-07d1-72b8-8cf6-7908daa237e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY5SfE6UR3ogRaE2Ah9kUaJU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_53989639f1e1d03529d50291",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Public Schools-Brevard County",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2700 Judge Fran Jamieson Way, Melbourne, FL 32940, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150f-1b35-729f-8a5e-608b592772e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-1b35-729f-8a5e-608b592772e3",
        "storage_key": "property/5717049565249536/019f150f-1b35-729f-8a5e-608b592772e3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14019595112528720884&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "public-schools-brevard-county",
      "poi_latitude": "28.2481315",
      "poi_longitude": "-80.736144",
      "poi_miles_from_property": "18.0 mi",
      "poi_walking_minutes": "6 hours 38 mins",
      "poi_biking_minutes": "1 hour 43 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 321-633-1000 ext. 11500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-0797-7161-8652-f8c3b5e1f301.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-0797-7161-8652-f8c3b5e1f301",
        "storage_key": "property/5717049565249536/019f150c-0797-7161-8652-f8c3b5e1f301.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJl-LOkLsG3ogR9LMT0Xmbj8I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_1a4ce5a28dbcf4b4f986eea3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "poi_name": "Brevard County Tax Collector Viera Branch",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2725 Judge Fran Jamieson Way A108, Melbourne, FL 32940, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150f-2043-700a-aa14-adad1fd1a821.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-2043-700a-aa14-adad1fd1a821",
        "storage_key": "property/5717049565249536/019f150f-2043-700a-aa14-adad1fd1a821.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.brevardtaxcollector.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6511526447070835714&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brevard-county-tax-collector-viera-branch",
      "poi_latitude": "28.2467159",
      "poi_longitude": "-80.7369157",
      "poi_miles_from_property": "18.3 mi",
      "poi_walking_minutes": "6 hours 43 mins",
      "poi_biking_minutes": "1 hour 42 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 321-633-2199",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150c-0a42-7581-8ae0-ba13d9aad641.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150c-0a42-7581-8ae0-ba13d9aad641",
        "storage_key": "property/5717049565249536/019f150c-0a42-7581-8ae0-ba13d9aad641.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfUhFFLwG3ogRAvQ3182WXVo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_c350cfa7-6959-4c6e-8472-64da81b29f15",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_2fb40e4b-d5c6-4030-9f20-128717417253",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_88755746-3c2e-4812-97d7-e3deda717846",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_c948589d-4e2a-4579-8b62-f0d11c268672",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_c9aa3274-37dc-401f-83ff-70cc3eadd297",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_52a9647d-9cb7-49ac-9e41-19ee2ca857ab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_bd599dd15d91420853b283ba",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "rating": "5",
      "name": "Tywon Brownlee",
      "text": "I have been out of Compass a year and my pillow is still wet from crying myself to sleep dealing with the complex I moved to in Rockledge to be closer to work on Merritt Island. The leasing office staff was nothing short of amazing. From the day I went to look at apartments initially up until the point I moved I always felt like they appreciated me living there and cared about the people they are providing homes for. The complex was always quiet and practically every neighbor in my building was always friendly and looking out for each other. The maintenance team was always on top of things, and there was never an issue with bugs or pests. And I got a lot of use out of the property gym facility. And I absolutely miss that covered parking! Compass is a great place to live.",
      "date": "2025-06-02",
      "title": "false"
    },
    {
      "id": "ec_b2a0071c128ed158ef6e0e3e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "rating": "5",
      "name": "Valerie Geffel",
      "text": "Compass is a nice place to live. It’s quiet and the staff are friendly and try their hardest to make repairs whatever they may be. Karen is so wonderful. She’s always pleasant and does a great job. She has so many apartments to oversee. She takes the time to listen even if it’s not apartment related. Augustine and Manuel the maintenance guys have so many apartments to take care of and there are only two of them. They are always kind and helpful when there is a problem that needs attention. I want to thank them for getting my place in great condition. This complex is older so they definitely have their fair share of issues but they are always addressed in an effective manner. Thank you to all of you.\nValerie 1005 I would like to add Nancy to my review. She also has always been helpful and is always happy and willing to listen to whatever it may be. Sorry Nancy. There wasn’t any reason why I left you out of my review. I apologize for not including you with the rest of the office workers. ❣️",
      "date": "2025-12-16",
      "title": "false"
    },
    {
      "id": "ec_5b11cb91515d96d03ca569e2",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "rating": "4",
      "name": "Meredith Bruns",
      "text": "While my husband and I have had our issues a with the apartment over the last almost 2 years we've lived here, one thing we've never had a problem with is Traci in the front office. When we originally toured the property it was Traci who showed us around and we fell in love with her vibrant personality. I was so glad to see her come back from the other property, Traci truly cares about the residents and any complaints we have had and brought to her attention had been dealt with swiftly.",
      "date": "2026-02-24",
      "title": "false"
    },
    {
      "id": "ec_ad8e57e8fb053e1c4d4abe55",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "rating": "5",
      "name": "Kay",
      "text": "I've had the privilege to live in this lovely little apartment for an entire year and it breaks my heart to leave, but alas good things all come to end sometimes. I would stay here for much much longer if I was not moving out of the country. I'm excited to step into this new chapter of my life, but it wouldn't have been possible without Nancy and the upper management staff to accept me as a tenant.\n\nI have never lived in a place that I felt so safe in before. Never once did I feel that I was in danger when stepping out of my apartment or walking around the complex. My neighbors were extremely kind and all the folks I met during walks to the mailboxes.\n\nOne thing that is important to know if you move here for the parcel lockers. If you are not receiving the code for your packages and need another way to access it, on the app (Parcel Pending), go into your account details, scroll down and there is a \"pin\" that you input on the computer screen in the locker room. That should help you get access to your packages if a code was never sent to your phone.\n> A raging storm must've done something to the internet or computer there that didn't send codes out so many people were left wondering what to do. Thankfully I was able to help a gentlemen when he was in there.\n\nOtherwise, thank you. This has been my favorite place to live in all my years of renting all over the United States.",
      "date": "2025-07-28",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_c397d58fa9f72bd691096c11",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f14c4-6e9b-723c-9e05-41e668add2a6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-6e9b-723c-9e05-41e668add2a6",
        "storage_key": "property/5717049565249536/019f14c4-6e9b-723c-9e05-41e668add2a6.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "Compass",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/YqH4-4kxxm4"
    }
  ],
  "faqs": [
    {
      "id": "custom_86bf732d-953f-4596-93b7-4a63d5b77769",
      "question": "Is Compass pet-friendly?",
      "answer": "Yes. Compass welcomes cats and dogs, up to 2 pets per home, with no posted weight limit. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For the full pet policy, call the leasing team at (321) 984-3161 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_c8c35dc2-df0b-4825-a4c1-461988969b97",
      "question": "How can I schedule a tour at Compass?",
      "answer": "You can schedule a tour of Compass online through our Schedule a Tour page, or call the leasing office at (321) 984-3161. You can also view our virtual tours to see the community before visiting in person.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_4e6f54d8-fd1e-4d1d-9d09-5619ba4e3c20",
      "question": "What are the leasing office hours at Compass?",
      "answer": "The Compass leasing office is open during these hours:\n\n• Monday: 9:00 AM to 6:00 PM\n• Tuesday: 9:00 AM to 6:00 PM\n• Wednesday: 9:00 AM to 6:00 PM\n• Thursday: 9:00 AM to 6:00 PM\n• Friday: 9:00 AM to 6:00 PM\n• Saturday: 10:00 AM to 5:00 PM\n\nHours may change around holidays. Call (321) 984-3161 or visit our contact page to confirm before you visit.",
      "category": "Office Hours",
      "source": "custom"
    },
    {
      "id": "custom_e285966a-5551-41ac-88fe-9cc98ffa4ad0",
      "question": "What floor plans are available at Compass?",
      "answer": "Compass offers 1- and 2-bedroom apartment homes ranging from approximately 540 to 1,078 square feet, across 4 floor plans. View layouts, square footage, and current availability on our Floor Plans page, or schedule a tour to see them in person.",
      "category": "Floor Plans & Units",
      "source": "custom"
    },
    {
      "id": "custom_52312ab0-9564-425d-8f88-bca03fa72136",
      "question": "What amenities does Compass have?",
      "answer": "Compass offers a range of community and in-home amenities. Community amenities include: LUXER Package Locker, Car Wash, Covered Parking, Fitness Center, Lake, Pool, Select Homes, Tennis Court, and Lounge. In-home features include: counters, fan, hard floors, kitchen appliances, kitchen islands, outside space, sink, tile backsplash, w&d included, and walk-in closet. See the complete list on our Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_c56d8abc-8dae-4b09-973b-c726df5e07bb",
      "question": "Where is Compass located?",
      "answer": "Compass is located at 3595 Misty Oak Dr, Melbourne FL 32901. Nearby you'll find dining at Moon River Cafe & Curiosities, shopping at Publix Super Market at Melbourne Shopping Center, and green space at Bean Park. Explore more on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    },
    {
      "id": "custom_228bbce5-0812-4ef2-8031-b7b3a1f2dea4",
      "question": "How do I apply to live at Compass?",
      "answer": "You can apply to live at Compass online through our Apply Now page, which walks you through each step. If you have questions, the leasing team can help. Call (321) 984-3161 or reach out through our contact page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_09473bfc-a168-4ae4-bd85-a73b583df1f6",
      "question": "What do I need to apply at Compass?",
      "answer": "Applicants should be ready to provide standard rental application information, including government-issued identification, proof of income, and rental history. Qualification requirements can vary, so we recommend confirming the current criteria with the Compass leasing team at (321) 984-3161 or on our contact page. When you're ready, start on the Apply Now page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_f296e16f-e33b-4ccc-b553-bdb5288c5440",
      "question": "What is the Landmark 360 program at Compass?",
      "answer": "Compass participates in American Landmark's Landmark 360 resident program, which includes three resident promises:\n\n• Move-In Satisfaction Promise: if you are not satisfied within your first 15 days, American Landmark will refund your deposit and waive lease-termination fees.\n• 48-Hour Maintenance Completion Promise: work orders are completed within 48 hours (Monday through Friday), with rent credits if that timeline is missed.\n• Relocation Promise: after six months on your lease, you can transfer to another American Landmark community without penalties, with 60 days' written notice.\nTo learn more, contact the leasing team at (321) 984-3161 or visit our contact page.",
      "category": "Resident Programs",
      "source": "custom"
    },
    {
      "id": "custom_3596d2bf-df36-495c-b298-999b9bbd1bc4",
      "question": "Does Compass have a pool?",
      "answer": "Yes. Compass has a swimming pool for residents. See it alongside our other community amenities on the Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_2d12ef74-12ff-4f27-80b2-0f853e6a2b4e",
      "question": "Does Compass have a fitness center?",
      "answer": "Yes. Compass has a fitness center for residents. See all amenities on the Amenities page, or schedule a tour to view it in person.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_7728b4f5-a779-462f-8f9c-ab4cd1526cb3",
      "question": "Does Compass offer virtual tours?",
      "answer": "Yes. Compass offers virtual tours of Compass. Start on our Virtual Tours page, then schedule an in-person tour when you are ready.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_49cd55c4-35db-40c4-a5b5-0e0a81de55cd",
      "question": "What do residents say about living at Compass?",
      "answer": "Residents frequently mention the helpful staff and responsive maintenance at Compass. One resident wrote: *\"Reasonable price for what is provided. Prime location to points of relevance, some by foot, other by car. Very friendly and supportive Office and maintenance staff.\"* Read more resident reviews on our Reviews page.",
      "category": "Resident Life",
      "source": "custom"
    },
    {
      "id": "custom_2002e8a3-a1c8-47a4-ba98-1756120a35ee",
      "question": "When was Compass built?",
      "answer": "Compass was built in 1986 and renovated in 2020. Schedule a tour to see the finishes in person.",
      "category": "Property History & Features",
      "source": "custom"
    },
    {
      "id": "custom_bacda5c5-88f3-422e-bdfd-2f90eeb1d516",
      "question": "What is the pet fee at Compass?",
      "answer": "Pets at Compass: cats and dogs are welcome, up to 2 per home, with no posted weight limit. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For details, contact the leasing team at (321) 984-3161 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_0de7589a-0d2d-481b-8b38-3061f5ba67af",
      "question": "What features are included in the apartments at Compass?",
      "answer": "Apartment homes at Compass include counters, fan, hard floors, kitchen appliances, kitchen islands, outside space, sink, tile backsplash, w&d included, and walk-in closet. Browse layouts on our Floor Plans page or schedule a tour.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_57a176d3-85fd-47c9-b36e-e186fe48bbae",
      "question": "What restaurants and shops are near Compass?",
      "answer": "Nearby restaurants and shops include Moon River Cafe & Curiosities, Mainstreet Pub, Crush XI Restaurant, and Aya Mediterranean Cuisine. See the full neighborhood guide on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-58d6-7689-8df2-f14826f5e734",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "compass",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536"
    },
    {
      "lead_collector_id": "0198aa45-593a-766f-a919-f6fa9c87e475",
      "lead_source": "FACEBOOK_ADS",
      "name": "compass",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536"
    },
    {
      "lead_collector_id": "0198aa45-599d-7769-8159-946a4bb7c386",
      "lead_source": "LANDING_PAGE",
      "name": "compass",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-for-rent-melbourne-fl",
      "search_query": "One Bedroom Apartments For Rent In Melbourne FL",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments For Rent In Melbourne FL",
      "h2_subtitle": "Discover the perfect blend of comfort and style at Compass. Our pet-friendly community offers waterfront access and modern amenities for an elevated living experience.",
      "page_copy": "If you are searching for one bedroom apartments for rent in Melbourne FL, you’ll love life at Compass. Our newly renovated one-bedroom apartments feature vaulted ceilings, large windows, and hardwood-style flooring, filling your space with bright Florida sunshine. Enjoy picturesque views of our tranquil community lake and cozy nights by the fireplace. When you’re ready to soak up some sun, take advantage of our shimmering resort-inspired swimming pool and elevate your exercise routine at the 24-hour strength and cardio fitness center. Located near notable shops, beaches, entertainment, and employers, Compass offers the ideal setting for modern living by the sea.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c0d-b796-71bd-865e-40753aaa94bc",
        "storage_key": "property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and palm trees.",
        "public_id": "019f6c0d-c107-70ba-996e-a6a68a3b794b",
        "storage_key": "property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Compass | One Bedroom Apartments For Rent In Melbourne FL",
      "seo_description": "Discover one bedroom apartments for rent in Melbourne FL at Compass. Enjoy waterfront access, modern amenities, and a pet-friendly community. Experience Compass today.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "page_item_url": "two-bedrooms-apartments-for-rent-melbourne-fl",
      "search_query": "Two Bedrooms Apartments For Rent In Melbourne FL",
      "category": "Floorplan",
      "h1_title": "Two Bedrooms Apartments For Rent In Melbourne FL",
      "h2_subtitle": "Experience modern living at Compass with our spacious two-bedroom apartments. Enjoy waterfront access and a range of amenities designed for your comfort.",
      "page_copy": "If you are searching for two bedrooms apartments for rent in Melbourne FL, Compass is the perfect place for you. Our newly renovated two-bedroom apartments feature vaulted ceilings, large windows, and hardwood-style flooring, creating a bright and inviting space. Enjoy the picturesque views of our tranquil community lake and cozy up by the fireplace on cooler nights. Take advantage of our resort-inspired swimming pool and the 24-hour strength and cardio fitness center to stay active. Located near the area’s most notable shops, beaches, entertainment, and employers, Compass offers the ideal setting for modern living by the sea. Experience the best of Melbourne, FL, at Compass.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c0d-b796-71bd-865e-40753aaa94bc",
        "storage_key": "property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and palm trees.",
        "public_id": "019f6c0d-c107-70ba-996e-a6a68a3b794b",
        "storage_key": "property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Compass | Two Bedrooms Apartments For Rent In Melbourne FL",
      "seo_description": "Find two bedrooms apartments for rent in Melbourne FL at Compass. Enjoy waterfront access, modern amenities, and a pet-friendly community. Discover Compass today.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-resort-inspired-pool-sundeck",
      "search_query": "Apartments For Rent Near Me with Resort-Inspired Pool w/ Sundeck Seating",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Resort-Inspired Pool w/ Sundeck Seating",
      "h2_subtitle": "Discover luxury living at Compass with our resort-inspired pool and sundeck seating. Enjoy a range of amenities designed to elevate your lifestyle.",
      "page_copy": "If you are searching for apartments for rent near me with resort-inspired pool w/ sundeck seating, Compass is the ideal choice. Our pet-friendly community offers one and two-bedroom apartments with incredible waterfront access and modern amenities. Enjoy the shimmering resort-inspired swimming pool and relax on the sundeck seating, perfect for soaking up the Florida sun. Our newly renovated apartments feature vaulted ceilings, large windows, and hardwood-style flooring, creating a bright and inviting space. Located near notable shops, beaches, entertainment, and employers, Compass provides the perfect setting for modern living by the sea. Experience the best of Melbourne, FL, at Compass.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c0d-b796-71bd-865e-40753aaa94bc",
        "storage_key": "property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and palm trees.",
        "public_id": "019f6c0d-c107-70ba-996e-a6a68a3b794b",
        "storage_key": "property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Compass | Apartments For Rent Near Me with Resort-Inspired Pool w/ Sundeck Seating",
      "seo_description": "Find apartments for rent near me with resort-inspired pool w/ sundeck seating at Compass. Enjoy waterfront access, modern amenities, and a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-24hr-strength-cardio-center",
      "search_query": "Apartments For Rent Near Me with 24-Hour Strength & Cardio Fitness Center",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with 24-Hour Strength & Cardio Fitness Center",
      "h2_subtitle": "Experience active living at Compass with our 24-hour strength and cardio fitness center. Enjoy a range of amenities designed to enhance your lifestyle.",
      "page_copy": "If you are searching for apartments for rent near me with 24-hour strength & cardio fitness center, Compass is the perfect place for you. Our pet-friendly community offers one and two-bedroom apartments with incredible waterfront access and modern amenities. Stay active at our 24-hour strength and cardio fitness center, equipped to meet all your exercise needs. Our newly renovated apartments feature vaulted ceilings, large windows, and hardwood-style flooring, creating a bright and inviting space. Located near notable shops, beaches, entertainment, and employers, Compass provides the ideal setting for modern living by the sea. Discover the best of Melbourne, FL, at Compass.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c0d-b796-71bd-865e-40753aaa94bc",
        "storage_key": "property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and palm trees.",
        "public_id": "019f6c0d-c107-70ba-996e-a6a68a3b794b",
        "storage_key": "property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Compass | Apartments For Rent Near Me with 24-Hour Strength & Cardio Fitness Center",
      "seo_description": "Find apartments for rent near me with 24-hour strength & cardio fitness center at Compass. Enjoy waterfront access, modern amenities, and a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "page_item_url": "apartments-for-rent-melbourne-fl-near-medical-center",
      "search_query": "Apartments For Rent In Melbourne FL Near Melbourne Regional Medical Center",
      "category": "POI",
      "h1_title": "Apartments For Rent In Melbourne FL Near Melbourne Regional Medical Center",
      "h2_subtitle": "Discover convenient living at Compass, located near Melbourne Regional Medical Center. Enjoy modern amenities and a pet-friendly community designed for your comfort.",
      "page_copy": "If you are searching for apartments for rent in Melbourne FL near Melbourne Regional Medical Center, Compass is the perfect place for you. Our pet-friendly community offers one and two-bedroom apartments with incredible waterfront access and modern amenities. Enjoy the convenience of living near Melbourne Regional Medical Center, known for its expert care, latest technology, and top distinction for patient safety. Our newly renovated apartments feature vaulted ceilings, large windows, and hardwood-style flooring, creating a bright and inviting space. Located near notable shops, beaches, entertainment, and employers, Compass provides the ideal setting for modern living by the sea. Discover the best of Melbourne, FL, at Compass.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c0d-b796-71bd-865e-40753aaa94bc",
        "storage_key": "property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and palm trees.",
        "public_id": "019f6c0d-c107-70ba-996e-a6a68a3b794b",
        "storage_key": "property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Compass | Apartments For Rent In Melbourne FL Near Melbourne Regional Medical Center",
      "seo_description": "Find apartments for rent in Melbourne FL near Melbourne Regional Medical Center at Compass. Enjoy waterfront access, modern amenities, and a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "page_item_url": "apartments-for-rent-melbourne-fl-near-palm-bay-hospital",
      "search_query": "Apartments For Rent In Melbourne FL Near Health First's Palm Bay Hospital",
      "category": "POI",
      "h1_title": "Apartments For Rent In Melbourne FL Near Health First's Palm Bay Hospital",
      "h2_subtitle": "Experience convenient living at Compass, located near Health First's Palm Bay Hospital. Enjoy modern amenities and a pet-friendly community designed for your comfort.",
      "page_copy": "If you are searching for apartments for rent in Melbourne FL near Health First's Palm Bay Hospital, Compass is the perfect place for you. Our pet-friendly community offers one and two-bedroom apartments with incredible waterfront access and modern amenities. Enjoy the convenience of living near Health First's Palm Bay Hospital, known for its cutting-edge technology and comprehensive healthcare services, including digital diagnostic radiology, surgery, and emergency care. Our newly renovated apartments feature vaulted ceilings, large windows, and hardwood-style flooring, creating a bright and inviting space. Located near notable shops, beaches, entertainment, and employers, Compass provides the ideal setting for modern living by the sea. Discover the best of Melbourne, FL, at Compass.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c0d-b796-71bd-865e-40753aaa94bc",
        "storage_key": "property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and palm trees.",
        "public_id": "019f6c0d-c107-70ba-996e-a6a68a3b794b",
        "storage_key": "property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Compass | Apartments For Rent In Melbourne FL Near Health First's Palm Bay Hospital",
      "seo_description": "Find apartments for rent in Melbourne FL near Health First's Palm Bay Hospital at Compass. Enjoy waterfront access, modern amenities, and a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "page_item_url": "apartments-for-rent-melbourne-fl-near-nemours-childrens",
      "search_query": "Apartments For Rent In Melbourne FL Near Nemours Children's Health, Melbourne",
      "category": "POI",
      "h1_title": "Apartments For Rent In Melbourne FL Near Nemours Children's Health, Melbourne",
      "h2_subtitle": "Discover convenient living at Compass, located near Nemours Children's Health, Melbourne. Enjoy modern amenities and a pet-friendly community designed for your comfort.",
      "page_copy": "If you are searching for apartments for rent in Melbourne FL near Nemours Children's Health, Melbourne, Compass is the perfect place for you. Our pet-friendly community offers one and two-bedroom apartments with incredible waterfront access and modern amenities. Enjoy the convenience of living near Nemours Children's Health, Melbourne, ensuring top-notch healthcare for your family. Our newly renovated apartments feature vaulted ceilings, large windows, and hardwood-style flooring, creating a bright and inviting space. Located near notable shops, beaches, entertainment, and employers, Compass provides the ideal setting for modern living by the sea. Discover the best of Melbourne, FL, at Compass.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c0d-b796-71bd-865e-40753aaa94bc",
        "storage_key": "property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and palm trees.",
        "public_id": "019f6c0d-c107-70ba-996e-a6a68a3b794b",
        "storage_key": "property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Compass | Apartments For Rent In Melbourne FL Near Nemours Children's Health, Melbourne",
      "seo_description": "Find apartments for rent in Melbourne FL near Nemours Children's Health, Melbourne at Compass. Enjoy waterfront access, modern amenities, and a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "page_item_url": "apartments-for-rent-melbourne-fl-near-kindred-hospital",
      "search_query": "Apartments For Rent In Melbourne FL Near Kindred Hospital Melbourne",
      "category": "POI",
      "h1_title": "Apartments For Rent In Melbourne FL Near Kindred Hospital Melbourne",
      "h2_subtitle": "Experience convenient living at Compass, located near Kindred Hospital Melbourne. Enjoy modern amenities and a pet-friendly community designed for your comfort.",
      "page_copy": "If you are searching for apartments for rent in Melbourne FL near Kindred Hospital Melbourne, Compass is the perfect place for you. Our pet-friendly community offers one and two-bedroom apartments with incredible waterfront access and modern amenities. Enjoy the convenience of living near Kindred Hospital Melbourne, specializing in the treatment and rehabilitation of post-intensive care and complex medical patients. Our newly renovated apartments feature vaulted ceilings, large windows, and hardwood-style flooring, creating a bright and inviting space. Located near notable shops, beaches, entertainment, and employers, Compass provides the ideal setting for modern living by the sea. Discover the best of Melbourne, FL, at Compass.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c0d-b796-71bd-865e-40753aaa94bc",
        "storage_key": "property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and palm trees.",
        "public_id": "019f6c0d-c107-70ba-996e-a6a68a3b794b",
        "storage_key": "property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Compass | Apartments For Rent In Melbourne FL Near Kindred Hospital Melbourne",
      "seo_description": "Find apartments for rent in Melbourne FL near Kindred Hospital Melbourne at Compass. Enjoy waterfront access, modern amenities, and a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "page_item_url": "apartments-for-rent-melbourne-fl-near-publix-pharmacy",
      "search_query": "Apartments For Rent In Melbourne FL Near Publix Pharmacy at Driftwood Plaza",
      "category": "POI",
      "h1_title": "Apartments For Rent In Melbourne FL Near Publix Pharmacy at Driftwood Plaza",
      "h2_subtitle": "Discover convenient living at Compass, located near Publix Pharmacy at Driftwood Plaza. Enjoy modern amenities and a pet-friendly community designed for your comfort.",
      "page_copy": "If you are searching for apartments for rent in Melbourne FL near Publix Pharmacy at Driftwood Plaza, Compass is the perfect place for you. Our pet-friendly community offers one and two-bedroom apartments with incredible waterfront access and modern amenities. Enjoy the convenience of living near Publix Pharmacy at Driftwood Plaza, where you can fill prescriptions, shop for over-the-counter medications, and receive patient counseling and health screenings. Our newly renovated apartments feature vaulted ceilings, large windows, and hardwood-style flooring, creating a bright and inviting space. Located near notable shops, beaches, entertainment, and employers, Compass provides the ideal setting for modern living by the sea. Discover the best of Melbourne, FL, at Compass.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c0d-b796-71bd-865e-40753aaa94bc",
        "storage_key": "property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and palm trees.",
        "public_id": "019f6c0d-c107-70ba-996e-a6a68a3b794b",
        "storage_key": "property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Compass | Apartments For Rent In Melbourne FL Near Publix Pharmacy at Driftwood Plaza",
      "seo_description": "Find apartments for rent in Melbourne FL near Publix Pharmacy at Driftwood Plaza at Compass. Enjoy waterfront access, modern amenities, and a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "page_item_url": "apartments-for-rent-melbourne-fl-near-efsc-campus",
      "search_query": "Apartments For Rent In Melbourne FL Near Eastern Florida State College - Melbourne Campus",
      "category": "POI",
      "h1_title": "Apartments For Rent In Melbourne FL Near Eastern Florida State College - Melbourne Campus",
      "h2_subtitle": "Discover convenient living at Compass, located near Eastern Florida State College - Melbourne Campus. Enjoy modern amenities and a pet-friendly community designed for your comfort.",
      "page_copy": "If you are searching for apartments for rent in Melbourne FL near Eastern Florida State College - Melbourne Campus, Compass is the perfect place for you. Our pet-friendly community offers one and two-bedroom apartments with incredible waterfront access and modern amenities. Enjoy the convenience of living near Eastern Florida State College - Melbourne Campus, offering over 100 associate and bachelor's degree options, career certificates, and home to the Public Safety and Health Sciences Institutes. Our newly renovated apartments feature vaulted ceilings, large windows, and hardwood-style flooring, creating a bright and inviting space. Located near notable shops, beaches, entertainment, and employers, Compass provides the ideal setting for modern living by the sea. Discover the best of Melbourne, FL, at Compass.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c0d-b796-71bd-865e-40753aaa94bc",
        "storage_key": "property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and palm trees.",
        "public_id": "019f6c0d-c107-70ba-996e-a6a68a3b794b",
        "storage_key": "property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Compass | Apartments For Rent In Melbourne FL Near Eastern Florida State College - Melbourne Campus",
      "seo_description": "Find apartments for rent in Melbourne FL near Eastern Florida State College - Melbourne Campus at Compass. Enjoy waterfront access, modern amenities, and a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-eastern-florida-college",
      "search_query": "Apartments For Rent In Melbourne FL Near Eastern Florida State College - Palm Bay Campus",
      "category": "POI",
      "h1_title": "Apartments For Rent In Melbourne FL Near Eastern Florida State College - Palm Bay Campus",
      "h2_subtitle": "Discover convenient living at Compass, located near Eastern Florida State College - Palm Bay Campus. Enjoy modern amenities and a pet-friendly community designed for your comfort.",
      "page_copy": "If you are searching for apartments for rent in Melbourne FL near Eastern Florida State College - Palm Bay Campus, Compass is the perfect place for you. Our pet-friendly community offers one and two-bedroom apartments with incredible waterfront access and modern amenities. Enjoy the convenience of living near Eastern Florida State College - Palm Bay Campus, offering over 100 associate and bachelor's degree options, career certificates, and home to the Fire Science Training Academy and the Center for Cybersecurity and Digital Forensics (CCDF). Our newly renovated apartments feature vaulted ceilings, large windows, and hardwood-style flooring, creating a bright and inviting space. Located near notable shops, beaches, entertainment, and employers, Compass provides the ideal setting for modern living by the sea. Discover the best of Melbourne, FL, at Compass.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c0d-b796-71bd-865e-40753aaa94bc",
        "storage_key": "property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and palm trees.",
        "public_id": "019f6c0d-c107-70ba-996e-a6a68a3b794b",
        "storage_key": "property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Compass | Apartments For Rent In Melbourne FL Near Eastern Florida State College - Palm Bay Campus",
      "seo_description": "Find apartments for rent in Melbourne FL near Eastern Florida State College - Palm Bay Campus at Compass. Enjoy waterfront access, modern amenities, and a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "page_item_url": "apartments-for-rent-in-melbourne-fl-near-keiser-university",
      "search_query": "Apartments For Rent In Melbourne FL Near Keiser University",
      "category": "POI",
      "h1_title": "Apartments For Rent In Melbourne FL Near Keiser University",
      "h2_subtitle": "Discover convenient living at Compass, located near Keiser University. Enjoy modern amenities and a pet-friendly community designed for your comfort.",
      "page_copy": "If you are searching for apartments for rent in Melbourne FL near Keiser University, Compass is the perfect place for you. Our pet-friendly community offers one and two-bedroom apartments with incredible waterfront access and modern amenities. Enjoy the convenience of living near Keiser University, providing a pleasant academic environment and full-time staff to assist with admissions, administration, and student services. Our newly renovated apartments feature vaulted ceilings, large windows, and hardwood-style flooring, creating a bright and inviting space. Located near notable shops, beaches, entertainment, and employers, Compass provides the ideal setting for modern living by the sea. Discover the best of Melbourne, FL, at Compass.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c0d-b796-71bd-865e-40753aaa94bc",
        "storage_key": "property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and palm trees.",
        "public_id": "019f6c0d-c107-70ba-996e-a6a68a3b794b",
        "storage_key": "property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Compass | Apartments For Rent In Melbourne FL Near Keiser University",
      "seo_description": "Find apartments for rent in Melbourne FL near Keiser University at Compass. Enjoy waterfront access, modern amenities, and a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "page_item_url": "apartments-for-rent-melbourne-fl-near-geospace-lab",
      "search_query": "Apartments For Rent In Melbourne FL Near Geospace Physics Laboratory",
      "category": "POI",
      "h1_title": "Apartments For Rent In Melbourne FL Near Geospace Physics Laboratory",
      "h2_subtitle": "Discover convenient living at Compass, located near Geospace Physics Laboratory. Enjoy modern amenities and a pet-friendly community designed for your comfort.",
      "page_copy": "If you are searching for apartments for rent in Melbourne FL near Geospace Physics Laboratory, Compass is the perfect place for you. Our pet-friendly community offers one and two-bedroom apartments with incredible waterfront access and modern amenities. Enjoy the convenience of living near the Geospace Physics Laboratory, providing a unique opportunity for those involved in scientific research and studies. Our newly renovated apartments feature vaulted ceilings, large windows, and hardwood-style flooring, creating a bright and inviting space. Located near notable shops, beaches, entertainment, and employers, Compass provides the ideal setting for modern living by the sea. Discover the best of Melbourne, FL, at Compass.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c0d-b796-71bd-865e-40753aaa94bc",
        "storage_key": "property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and palm trees.",
        "public_id": "019f6c0d-c107-70ba-996e-a6a68a3b794b",
        "storage_key": "property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Compass | Apartments For Rent In Melbourne FL Near Geospace Physics Laboratory",
      "seo_description": "Find apartments for rent in Melbourne FL near Geospace Physics Laboratory at Compass. Enjoy waterfront access, modern amenities, and a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "page_item_url": "apartments-for-rent-melbourne-fl-near-university-florida",
      "search_query": "Apartments For Rent In Melbourne FL Near University of Florida Surgeons",
      "category": "POI",
      "h1_title": "Apartments For Rent In Melbourne FL Near University of Florida Surgeons",
      "h2_subtitle": "Discover convenient living at Compass, located near University of Florida Surgeons. Enjoy modern amenities and a pet-friendly community designed for your comfort.",
      "page_copy": "If you are searching for apartments for rent in Melbourne FL near University of Florida Surgeons, Compass is the perfect place for you. Our pet-friendly community offers one and two-bedroom apartments with incredible waterfront access and modern amenities. Enjoy the convenience of living near University of Florida Surgeons, providing top-notch medical care and expertise. Our newly renovated apartments feature vaulted ceilings, large windows, and hardwood-style flooring, creating a bright and inviting space. Located near notable shops, beaches, entertainment, and employers, Compass provides the ideal setting for modern living by the sea. Discover the best of Melbourne, FL, at Compass.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c0d-b796-71bd-865e-40753aaa94bc",
        "storage_key": "property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and palm trees.",
        "public_id": "019f6c0d-c107-70ba-996e-a6a68a3b794b",
        "storage_key": "property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Compass | Apartments For Rent In Melbourne FL Near University of Florida Surgeons",
      "seo_description": "Find apartments for rent in Melbourne FL near University of Florida Surgeons at Compass. Enjoy waterfront access, modern amenities, and a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "page_item_url": "apartments-for-rent-melbourne-fl-near-indialantic-school",
      "search_query": "Apartments For Rent In Melbourne FL Near Indialantic Elementary School",
      "category": "POI",
      "h1_title": "Apartments For Rent In Melbourne FL Near Indialantic Elementary School",
      "h2_subtitle": "Discover convenient living at Compass, located near Indialantic Elementary School. Enjoy modern amenities and a pet-friendly community designed for your comfort.",
      "page_copy": "If you are searching for apartments for rent in Melbourne FL near Indialantic Elementary School, Compass is the perfect place for you. Our pet-friendly community offers one and two-bedroom apartments with incredible waterfront access and modern amenities. Enjoy the convenience of living near Indialantic Elementary School, providing quality education for your children. Our newly renovated apartments feature vaulted ceilings, large windows, and hardwood-style flooring, creating a bright and inviting space. Located near notable shops, beaches, entertainment, and employers, Compass provides the ideal setting for modern living by the sea. Discover the best of Melbourne, FL, at Compass.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c0d-b796-71bd-865e-40753aaa94bc",
        "storage_key": "property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and palm trees.",
        "public_id": "019f6c0d-c107-70ba-996e-a6a68a3b794b",
        "storage_key": "property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Compass | Apartments For Rent In Melbourne FL Near Indialantic Elementary School",
      "seo_description": "Find apartments for rent in Melbourne FL near Indialantic Elementary School at Compass. Enjoy waterfront access, modern amenities, and a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "page_item_url": "apartments-for-rent-melbourne-fl-near-gemini-school",
      "search_query": "Apartments For Rent In Melbourne FL Near Gemini Elementary School",
      "category": "POI",
      "h1_title": "Apartments For Rent In Melbourne FL Near Gemini Elementary School",
      "h2_subtitle": "Discover convenient living at Compass, located near Gemini Elementary School. Enjoy modern amenities and a pet-friendly community designed for your comfort.",
      "page_copy": "If you are searching for apartments for rent in Melbourne FL near Gemini Elementary School, Compass is the perfect place for you. Our pet-friendly community offers one and two-bedroom apartments with incredible waterfront access and modern amenities. Enjoy the convenience of living near Gemini Elementary School, providing quality education for your children. Our newly renovated apartments feature vaulted ceilings, large windows, and hardwood-style flooring, creating a bright and inviting space. Located near notable shops, beaches, entertainment, and employers, Compass provides the ideal setting for modern living by the sea. Discover the best of Melbourne, FL, at Compass.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c0d-b796-71bd-865e-40753aaa94bc",
        "storage_key": "property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and palm trees.",
        "public_id": "019f6c0d-c107-70ba-996e-a6a68a3b794b",
        "storage_key": "property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Compass | Apartments For Rent In Melbourne FL Near Gemini Elementary School",
      "seo_description": "Find apartments for rent in Melbourne FL near Gemini Elementary School at Compass. Enjoy waterfront access, modern amenities, and a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "page_item_url": "apartments-for-rent-in-melbourne-fl-near-jupiter",
      "search_query": "Apartments For Rent In Melbourne FL Near Jupiter Elementary School",
      "category": "POI",
      "h1_title": "Apartments For Rent In Melbourne FL Near Jupiter Elementary School",
      "h2_subtitle": "Discover convenient living at Compass, located near Jupiter Elementary School. Enjoy modern amenities and a pet-friendly community designed for your comfort.",
      "page_copy": "If you are searching for apartments for rent in Melbourne FL near Jupiter Elementary School, Compass is the perfect place for you. Our pet-friendly community offers one and two-bedroom apartments with incredible waterfront access and modern amenities. Enjoy the convenience of living near Jupiter Elementary School, providing quality education for your children. Our newly renovated apartments feature vaulted ceilings, large windows, and hardwood-style flooring, creating a bright and inviting space. Located near notable shops, beaches, entertainment, and employers, Compass provides the ideal setting for modern living by the sea. Discover the best of Melbourne, FL, at Compass.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c0d-b796-71bd-865e-40753aaa94bc",
        "storage_key": "property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and palm trees.",
        "public_id": "019f6c0d-c107-70ba-996e-a6a68a3b794b",
        "storage_key": "property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Compass | Apartments For Rent In Melbourne FL Near Jupiter Elementary School",
      "seo_description": "Find apartments for rent in Melbourne FL near Jupiter Elementary School at Compass. Enjoy waterfront access, modern amenities, and a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "page_item_url": "apartments-for-rent-melbourne-fl-near-odyssey-school",
      "search_query": "Apartments For Rent In Melbourne FL Near Odyssey Charter School",
      "category": "POI",
      "h1_title": "Apartments For Rent In Melbourne FL Near Odyssey Charter School",
      "h2_subtitle": "Discover convenient living at Compass, located near Odyssey Charter School. Enjoy modern amenities and a pet-friendly community designed for your comfort.",
      "page_copy": "If you are searching for apartments for rent in Melbourne FL near Odyssey Charter School, Compass is the perfect place for you. Our pet-friendly community offers one and two-bedroom apartments with incredible waterfront access and modern amenities. Enjoy the convenience of living near Odyssey Charter School, a state-funded charter school providing quality education for your children. Our newly renovated apartments feature vaulted ceilings, large windows, and hardwood-style flooring, creating a bright and inviting space. Located near notable shops, beaches, entertainment, and employers, Compass provides the ideal setting for modern living by the sea. Discover the best of Melbourne, FL, at Compass.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c0d-b796-71bd-865e-40753aaa94bc",
        "storage_key": "property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and palm trees.",
        "public_id": "019f6c0d-c107-70ba-996e-a6a68a3b794b",
        "storage_key": "property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Compass | Apartments For Rent In Melbourne FL Near Odyssey Charter School",
      "seo_description": "Find apartments for rent in Melbourne FL near Odyssey Charter School at Compass. Enjoy waterfront access, modern amenities, and a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "page_item_url": "apartments-for-rent-melbourne-fl-near-palm-bay",
      "search_query": "Apartments For Rent In Melbourne FL Near Palm Bay Elementary",
      "category": "POI",
      "h1_title": "Apartments For Rent In Melbourne FL Near Palm Bay Elementary",
      "h2_subtitle": "Discover convenient living at Compass, located near Palm Bay Elementary. Enjoy modern amenities and a pet-friendly community designed for your comfort.",
      "page_copy": "If you are searching for apartments for rent in Melbourne FL near Palm Bay Elementary, Compass is the perfect place for you. Our pet-friendly community offers one and two-bedroom apartments with incredible waterfront access and modern amenities. Enjoy the convenience of living near Palm Bay Elementary, providing quality education for your children. Our newly renovated apartments feature vaulted ceilings, large windows, and hardwood-style flooring, creating a bright and inviting space. Located near notable shops, beaches, entertainment, and employers, Compass provides the ideal setting for modern living by the sea. Discover the best of Melbourne, FL, at Compass.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c0d-b796-71bd-865e-40753aaa94bc",
        "storage_key": "property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and palm trees.",
        "public_id": "019f6c0d-c107-70ba-996e-a6a68a3b794b",
        "storage_key": "property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Compass | Apartments For Rent In Melbourne FL Near Palm Bay Elementary",
      "seo_description": "Find apartments for rent in Melbourne FL near Palm Bay Elementary at Compass. Enjoy waterfront access, modern amenities, and a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5717049565249536",
      "source": "custom",
      "page_item_url": "apartments-for-rent-melbourne-fl-near-university-park",
      "search_query": "Apartments For Rent In Melbourne FL Near University Park Elementary School",
      "category": "POI",
      "h1_title": "Apartments For Rent In Melbourne FL Near University Park Elementary School",
      "h2_subtitle": "Discover family-friendly living at Compass, located just 2.1 km from University Park Elementary School. Enjoy modern amenities and a pet-friendly community designed for your comfort.",
      "page_copy": "If you are searching for apartments for rent in Melbourne FL near University Park Elementary School, Compass is the perfect place for you. Our pet-friendly community offers one and two-bedroom apartments with incredible waterfront access and modern amenities. Located just 2.1 km from University Park Elementary School, Compass is ideal for families looking for quality education for their children. Our newly renovated apartments feature vaulted ceilings, large windows, and hardwood-style flooring, creating a bright and inviting space. Enjoy picturesque views of our tranquil community lake and cozy nights by the fireplace. Take advantage of our resort-inspired swimming pool and the 24-hour strength and cardio fitness center. Located near notable shops, beaches, entertainment, and employers, Compass provides the ideal setting for modern living by the sea. Discover the best of Melbourne, FL, at Compass.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c0d-b796-71bd-865e-40753aaa94bc",
        "storage_key": "property/5717049565249536/019f6c0d-b796-71bd-865e-40753aaa94bc.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and palm trees.",
        "public_id": "019f6c0d-c107-70ba-996e-a6a68a3b794b",
        "storage_key": "property/5717049565249536/019f6c0d-c107-70ba-996e-a6a68a3b794b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Compass | Apartments For Rent In Melbourne FL Near University Park Elementary School",
      "seo_description": "Find apartments for rent in Melbourne FL near University Park Elementary School at Compass. Enjoy waterfront access, modern amenities, and a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2153"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2376470894"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a25\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a25\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4597232"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WFHJ8ZT"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "1"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "6732042114"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "3b011f195b60118d"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/960p7odnv7n"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/020ab39f-6f45-4017-ba72-da1257fb8d6e"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "689-488-7210"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjFIRjFMR2NzNEpKcVBTcCt0VGR0YUE9PSIsInZhbHVlIjoiSC9rbHQ3dUJJV1lveUM3YTBGRFVNdz09IiwibWFjIjoiZTZhNzNiNWQzOWE1ZTY1OGI5NzhmNTE0ZGIyZDU2OTZkMjIwNjY5ZGNiM2ExMDlhODg2OWE1YjQwMjM5ZmEwNiJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2153",
  "custom_repli_id": "2376470894",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a25\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a25\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4597232",
  "custom_google_gtm_id": "GTM-WFHJ8ZT",
  "custom_rollout_phase": "1",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "6732042114",
  "custom_knock_community_id": "3b011f195b60118d",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/960p7odnv7n",
  "custom_self_guided_tour_url": "https://selftournow.com/property/020ab39f-6f45-4017-ba72-da1257fb8d6e",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "689-488-7210",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjFIRjFMR2NzNEpKcVBTcCt0VGR0YUE9PSIsInZhbHVlIjoiSC9rbHQ3dUJJV1lveUM3YTBGRFVNdz09IiwibWFjIjoiZTZhNzNiNWQzOWE1ZTY1OGI5NzhmNTE0ZGIyZDU2OTZkMjIwNjY5ZGNiM2ExMDlhODg2OWE1YjQwMjM5ZmEwNiJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "95401512-4934-4b1e-9e3e-fe57945b9146",
  "custom_audioeye_site_hash": "e399812b2cb37ade7524824430237f38"
};

export const generatedAt = '2026-11-03T20:37:44.244Z';
